// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * fix-sprint-20260620-2109-followup-2-followup — Extracted module_tips.
 *
 * ca.ts exceeded the ~1MB MCP transport payload limit, blocking any
 * push of i18n updates against it. The largest top-level section
 * (module_tips) lives here so the main file stays under the limit.
 * Import is spread back into ca.ts at module load — runtime shape
 * is unchanged.
 *
 * Same pattern as vi-extras.ts (added in fix-sprint-20260511-2113).
 */
export const caModuleTips = {
    show_guide: 'Mostra la guia',
    boundary_show_statements: 'Show statements',
    boundary_hide_statements: 'Hide statements',
    boundary_summary: '{count} statement(s) from {frameworks} installed framework(s)',
    hide_guide: 'Amaga la guia',
    title: 'Guia del mòdul',
    title_prefix: 'Consell de mòdul:',
    loading_aria: 'Carregant consell de mòdul',
    dismiss: 'Tanca la guia del mòdul',
    related_frameworks: 'Marcs reguladors relacionats',
    quick_start_label: 'Inici ràpid',
    related_forms_note: 'Els formularis de compliment relacionats estan disponibles a continuació — cerqueu la insígnia Mẫu số per identificar formularis reguladors oficials vietnamites.',
    read_full_guide: 'Llegeix la guia completa',
    view_full_requirements: 'Veure tots els requisits',
    relevant_for: 'Rellevant per a',
    key_procedure: 'Procediment clau',
    deletion_orchestration: "Coordinació de sol·licituds d'eliminació de dades entre sistemes i proveïdors amb fluxos de verificació i registres d'auditoria.",
    rights_requests: 'Gestioneu sol·licituds de drets dels interessats incloent accés, supressió, rectificació i portabilitat. Requerit per la Llei PDPL 91/2025 i GDPR.',
    consent: 'Gestioneu polítiques i fluxos de recollida de consentiment. Requerit per al compliment de PDPL, Llei de Comerç Electrònic i GDPR.',
    consent_properties: "Configureu punts de recollida de consentiment i propietats d'integració CMP per al seguiment de consentiment web i d'aplicacions.",
    data_mapping: 'Mapeu fluxos de dades a la vostra organització — activitats de processament, sistemes i transferències transfrontereres.',
    data_mapping_registry: "Manteniu un inventari per camp de cada element de dades personals que té la vostra organització. Adjunteu cada element a una categoria de dades, anul·leu la sensibilitat o la retenció quan sigui necessari i importeu-los des de registres reguladors (PDPL inventari de dades personals) sense perdre les edicions de l'operador.",
    data_mapping_ropa_completeness: "Auditoria d'higiene per camp de cada Activitat de processament amb els camps ROPA obligatoris del marc (PDPL, GDPR, Decret 165). Identifiqueu els errors crítics / alts / condicionals abans de l'enviament regulatori i aneu directament a l'editor d'activitats per solucionar-los.",
    assessments: "Creeu i gestioneu Avaluacions d'Impacte en la Protecció de Dades (DPIA) i avaluacions de risc de sistemes d'IA. Requerit per l'Article 24 de la Llei PDPL 91/2025.",
    classification: 'Classifiqueu i etiqueteu actius de dades per sensibilitat, categoria i requisits reguladors.',
    incidents: 'Registreu i gestioneu incidents de seguretat i violacions de dades. Requerit per a la notificació de violacions sota PDPL i Llei de Ciberseguretat.',
    incident_ops: "Coordineu operacions de resposta a incidents amb activacions de playbooks, rutes d'escalat i taulers de coordinació en temps real.",
    monitoring: "Monitoritzeu KPIs de compliment, salut del programa i taxes de finalització de tasques a tota l'organització.",
    vendor_risk: 'Avalueu i gestioneu riscos de proveïdors mitjançant qüestionaris, carteres de risc i puntuació de compliment.',
    governance: 'Gestioneu la governança de proveïdors, playbooks i requisits de compliment de tercers.',
    program_governance: 'Configureu avaluacions de maduresa de governança de programa, mètriques de tauler i marcs de puntuació de compliment.',
    discovery: 'Descobriu i inventarieu actius de dades a la vostra organització amb escaneig automatitzat i fluxos de classificació.',
    discovery_cycles: 'Programeu i executeu cicles de descobriment recurrents que tornen a escanejar sistemes, mostren canvis delta i encaminen els resultats per revisió, aprovació i publicació.',
    connectors: 'Configureu integracions i connectors de dades per a la recollida automatitzada de dades de compliment.',
    task_management: 'Gestioneu tasques de compliment, assignacions i terminis entre equips i mòduls.',
    audit_trail: "Consulteu i cerqueu al registre d'auditoria unificat per a totes les activitats de compliment i recollida d'evidència.",
    evidence_packs: "Muntar, verificar i enviar paquets d'evidència d'auditoria per al compliment de la normativa. Els paquets d'evidència recullen esdeveniments d'auditoria per marc, tipus d'entitat i període de temps en paquets exportables per a la revisió interna o la presentació normativa.",
    audit_periods: "Definir i gestionar els períodes d'informes d'auditoria segons el marc normatiu. Els períodes d'auditoria estableixen els límits de temps i les polítiques de retenció per a la recollida d'evidències i els cicles d'informes de compliment.",
    qs_evidence_pack: 'Munta el teu primer paquet de proves',
    qs_audit_period: "Crear un període d'informes d'auditoria",
    compliance_forms: 'Exploreu el catàleg de formularis de compliment i creeu instàncies de formularis per a presentacions reguladores.',
    sector_overlays: 'Install the optional sector overlays your organisation is subject to, choose Direct or Reference only for each, and work in the sector registers an overlay installed Direct brings into use, grouped by sector under Sector Overlays. Available in the Enterprise package.',
    sector_overlays_overview: 'Sector Overlays › Overlay Management › Overview: the sector registers your active overlays bring into use, grouped by sector, with the overlays that provide each group and the shared views each sector uses elsewhere in the menu. A sector group appears here and in the Sector Overlays menu only while an overlay that declares it is installed Direct; an overlay installed Reference only adds no views. Install overlays and change their mode in Sector Overlays › Overlay Management › Overlay Catalog.',
    partner_workspace: "Gestió d'espais de treball de socis i revenedors amb accés delimitat, fluxos de revisió de compliment i eines de col·laboració.",
    localization: 'Gestioneu marcs reguladors, paquets de llengües i configuració de localització.',
    onboarding: "Seguiu el progrés d'incorporació, completeu inicis ràpids i seguiu rutes de compliment basades en persona.",
    organizations: "Gestioneu l'estructura organitzativa, departaments i configuracions multiorganització.",
    privacy_scanner: 'Monitoritzeu el compliment de privadesa del lloc web amb escaneig automatitzat i detecció de problemes.',
    access_accountability: "Configureu campanyes de revisió d'accés i polítiques de responsabilitat per a la governança d'accés a dades.",
    dashboard: "Consulteu la visió general del tauler de compliment amb resums d'estat en temps real, cobertura del marc i mètriques clau de compliment.",
    platform: "Gestioneu la configuració de seguretat de la plataforma, incloses les claus API, l'accés d'emergència de trencaclosques i la configuració de SSO.",
    framework_vn_pdpl: 'VN Llei de Protecció de Dades Personals (PDPL)',
    framework_vn_cybersecurity: 'VN Llei de Ciberseguretat',
    framework_vn_ecommerce: 'VN Llei de Comerç Electrònic',
    framework_vn_ai_law: "VN Llei d'IA",
    framework_vn_telecom: 'VN Llei de Telecomunicacions',
    framework_vn_banking_circular_83: 'Circular bancària VN 83/2025/TT-NHNN — Sistema de control intern',
    framework_gdpr: 'EU GDPR',
    cross_framework: 'Intermarcs — dona suport a totes les activitats de compliment regulador',
    qs_dpia_filing: 'Completeu la vostra primera presentació de DPIA',
    qs_dept_compliance: 'Envieu la vostra primera secció de compliment departamental',
    qs_ecommerce_consent: 'Prepare your e-commerce platform registration dossier',
    qs_telecom_data: 'Configureu la gestió de dades de subscriptors de telecomunicacions',
    qs_data_flow: 'Mapeu el vostre primer flux de dades',
    qs_incident_response: 'Configureu el flux de resposta a incidents',
    qs_ai_risk: "Executeu una avaluació de risc de sistema d'IA",
    qs_cross_border: 'Avalueu una transferència de dades transfronterera',
    qs_breach_notification: 'Simuleu un flux de notificació de violació',
    qs_audit_trail: "Reviseu un registre d'auditoria de compliment",
    procedure_data_deletion_fulfillment: "Compliment d'eliminació de dades",
    procedure_cross_system_deletion: 'Eliminació entre sistemes',
    procedure_dsar_intake: 'Recepció de sol·licituds de drets',
    procedure_cmp_property_config: 'Configuració de propietats CMP',
    procedure_consent_collection: 'Política de recollida de consentiment',
    procedure_ropa_filing: "Registre d'activitats de tractament",
    procedure_cross_border_assessment: 'Avaluació de transferència transfronterera',
    procedure_data_classification: 'Classificació de dades',
    procedure_breach_notification: 'Notificació de violació de dades',
    procedure_incident_timeline: "Seguiment de la cronologia d'incidents",
    procedure_playbook_escalation: 'Escalament segons guia operativa',
    procedure_compliance_kpi_monitoring: 'Monitoratge de KPI de compliment',
    procedure_vendor_risk_assessment: 'Avaluació de risc de proveïdors',
    procedure_transfer_mechanism_review: 'Revisió del mecanisme de transferència',
    procedure_program_maturity: 'Avaluació de maduresa del programa',
    procedure_data_discovery: "Descobriment d'actius de dades",
    procedure_connector_setup: 'Configuració de connectors',
    procedure_task_assignment: 'Assignació i delegació de tasques',
    procedure_audit_evidence: "Recollida d'evidències d'auditoria",
    procedure_form_submission: 'Enviament de formularis de compliment',
    procedure_partner_onboarding: "Flux d'incorporació de socis",
    procedure_partner_access: 'Accés i permisos de socis',
    procedure_framework_pack_install: 'Instal·lació del paquet de marc normatiu',
    procedure_language_pack_deploy: "Desplegament del paquet d'idioma",
    procedure_org_onboarding: "Configuració d'incorporació organitzacional",
    procedure_multi_org_config: 'Configuració multi-organització',
    procedure_privacy_scan: 'Escaneig de compliment de privadesa',
    procedure_access_review: "Campanya de revisió d'accessos",
    procedure_dpia_filing: "Procés de presentació d'AIPD",
    security: "Configuració de seguretat de la plataforma: API gestió de claus, polítiques de sessió, aplicació de l'MFA, integració d'SSO, llistes d'IP permeses i controls d'accés d'emergència trencament de vidre.",
    settings: "Configuració de tota la plataforma: preferències de notificació, gestió de dominis, programes d'exportació i configuració de mòduls per a la vostra organització.",
    users: "Gestió de comptes d'usuari: creeu i gestioneu comptes d'usuari, assigneu rols, configureu la pertinença al departament i feu un seguiment de l'activitat d'inici de sessió.",
    roles: 'Gestió de rols i permisos: definiu rols personalitzats, configureu permisos granulars per mòdul i apliqueu polítiques de separació de funcions.',
    profile: "La configuració del vostre perfil personal: nom de visualització, dades de contacte, preferència d'idioma, preferències de guia de mòduls, opcions d'accessibilitat i gestió de contrasenyes.",
    consent_properties_bindings: "Gestioneu els enllaços de polítiques de consentiment a les propietats digitals. Feu un seguiment de quina versió de la política s'implementa a cada propietat, identifiqueu els enllaços obsolets i coordineu el desplegament de polítiques.",
    consent_properties_templates: 'Gestió de plantilles daurades: definiu configuracions de consentiment estàndard, compareu propietats amb plantilles i introduïu canvis a les plantilles entre els grups de propietats.',
    consent_properties_compliance: "Supervisió del compliment del consentiment: detecteu les inconsistències de configuració entre propietats i plantilles daurades, gestioneu les sol·licituds de canvi mitjançant fluxos de treball d'aprovació i genereu paquets d'evidència per a la preparació per a l'auditoria.",
    consent_properties_operations: "Gestió operativa de les propietats de consentiment: configureu programes d'instantànies automatitzades, organitzeu les propietats en grups i reviseu la pista d'auditoria de propietats de consentiment.",
    consent_properties_audit: "Auditoria i anàlisi de la propietat del consentiment: reviseu l'historial de canvis de configuració, analitzeu les tendències de compliment de la propietat i genereu informes de compliment per a la revisió normativa.",
    classification_taxonomies: 'Definir i gestionar taxonomies de classificació de dades amb dimensions de sensibilitat i importància. Configura els nivells de classificació, els requisits de gestió i els AI nivells de risc.',
    classification_labeling: "Aplicar etiquetes de classificació als actius de dades. Envieu etiquetes per revisar-les, gestioneu la classificació massiva i feu un seguiment de l'estat de l'etiquetatge al vostre inventari de dades.",
    classification_lifecycle: 'Feu un seguiment del cicle de vida dels actius de dades classificats a través de les etapes: esborrany, ús actiu, en revisió, arxivat i pendent de supressió. Superviseu els períodes de retenció i activeu els fluxos de treball de supressió.',
    classification_gaps: 'Detecteu i gestioneu els buits de classificació al vostre inventari de dades. Executeu la detecció de buits per identificar els actius sense etiquetar i les assignacions del cicle de vida que falten i, a continuació, feu un seguiment de la correcció.',
    classification_reviews: "Gestioneu les tasques de revisió de classificació amb temporitzadors d'escalada. Reviseu les etiquetes proposades, gestioneu les excepcions i assegureu-vos de prendre decisions de classificació oportunes.",
    incidents_breach: "Gestioneu les notificacions d'incompliment de dades i els informes d'autoritats. Creeu paquets de notificacions, feu un seguiment dels terminis reglamentaris i documenteu el calendari complet de resposta a l'incompliment.",
    incidents_authority: "Gestionar les sol·licituds formals d'autoritat dels organismes reguladors. Feu un seguiment de les consultes entrants, reuniu paquets de proves, gestioneu llistes de verificació i compliu els terminis de resposta.",
    incidents_disclosure: "Mantenir el registre centralitzat de divulgació de totes les comunicacions amb les autoritats reguladores. Enregistreu les dates de divulgació, els canals, els destinataris i els resums de contingut per al compliment de la pista d'auditoria.",
    incidents_reports: "Generar i gestionar informes d'incidències per a la revisió interna i la presentació normativa. Creeu resums detallats d'incidències, feu un seguiment de l'estat de l'informe i exporteu documentació per a la presentació d'autoritats.",
    incidents_tasks: 'Coordinar les tasques de resposta a incidents entre els equips. Creeu llistes de comprovació de tasques, assigneu propietaris, feu un seguiment de prioritats i dependències, augmenteu els elements bloquejats i superviseu el progrés de finalització.',
    incidents_supplements: "Gestionar la documentació complementària sol·licitada per les autoritats reguladores després de la notificació inicial d'incompliment. Feu un seguiment de les sol·licituds de suplements, prepareu paquets de resposta i controleu els terminis de presentació.",
    incidents_remediation: "Feu un seguiment de les accions correctives assignades als departaments i usuaris per abordar la causa i l'impacte de les incidències. Supervisar els terminis d'implementació, verificar la finalització i documentar proves de correcció.",
    incident_ops_playbooks: "Crear i gestionar llibres de joc de resposta a incidents. Definiu camins d'escalada, assigneu equips de resposta i activeu llibres de jugades durant incidents en directe.",
    incident_ops_sla: 'Feu un seguiment dels SLA de resposta a incidents i dels terminis reglamentaris. Supervisar el compliment dels terminis de notificació legals i mesurar les mètriques de rendiment de la resposta.',
    incident_ops_evidence: "Mantenir les cadenes d'evidència d'incidències i realitzar revisions posteriors a l'incident. Genereu paquets d'exportació preparats pel regulador amb documentació completa d'incidències.",
    data_mapping_systems: 'Registrar i gestionar sistemes que tracten dades personals. Documentar la propietat del sistema, les categories de dades, les finalitats del processament i la puntuació de compliment.',
    data_mapping_flows: 'Mapejar els fluxos de dades entre sistemes, incloses les transferències transfrontereres. Documenteu les rutes de moviment de dades, els mecanismes de transferència i les jurisdiccions receptores.',
    data_mapping_activities: "Documentar les activitats de processament i generar Registres d'Activitats de Processament (RoPA). Enllaçar activitats amb bases legals, finalitats i categories de dades.",
    data_mapping_governance: "Gestioneu les assignacions de govern de dades, els cicles d'acreditació i les avaluacions de riscos. Feu un seguiment de la propietat del govern i reviseu els horaris del vostre inventari de dades.",
    data_mapping_reference: "Gestioneu les dades de referència per al mapatge de dades: categories de dades, finalitats de processament, polítiques de retenció i configuracions d'exportació.",
    data_mapping_categories: 'Gestioneu el catàleg de categories de dades: noms, nivells de sensibilitat, exemples i etiquetes. Base per a cada activitat de classificació i cartografia.',
    data_mapping_purposes: 'Finalitats del tractament del catàleg amb la seva base legal. Utilitzat per ROPA, DPIA i auditories de legalitat.',
    data_mapping_retention: "Configura polítiques de retenció, mètodes d'eliminació i cadència de revisió. Alinea amb els requisits del Decret 13/2023 i el Decret 356/2025.",
    data_mapping_exports: 'Exporteu ROPA, sistemes, propòsits i categories a CSV, XLSX, PDF o DOCX. Totes les exportacions aterren a la plataforma Navegador de fitxers.',
    data_mapping_attestation: "Programar i supervisar els cicles de certificació de dades. Feu un seguiment de la finalització de l'acreditació al vostre inventari de dades.",
    data_mapping_review: "Cua de revisió de classificació: tasques de revisió, senyals de qualitat i estat d'aprovació.",
    data_mapping_risk: "Avaluació de riscos per a les activitats de processament: marcs de puntuació, plans de mitigació i seguiment de l'eficàcia.",
    data_mapping_evidence: 'Evidència vinculada a activitats de processament: certificats de seguretat, contractes DPA, informes DPIA.',
    data_mapping_inventory: "Visió general de l'inventari de classificació: etiquetes, nivells de sensibilitat i distribució a tota l'organització.",
    data_mapping_exceptions: "Registre d'excepcions per a classificacions: justificació, aprovador, finestra de validesa i camí de correcció.",
    data_mapping_history: 'Historial de canvis de classificació: qui va canviar què, quan i per què.',
    access_accountability_logs: "Flux en temps real d'esdeveniments d'accés privilegiat. Vincula amb la pàgina de polítiques per definir qui pot arribar a cada zona de dades; combinar amb investigacions per fer un seguiment de les anomalies.",
    access_accountability_policies: "Creació de polítiques de zona d'accés: declareu quins rols i usuaris poden arribar a cada zona de dades, amb excepcions limitades en el temps. Impulsa les comprovacions d'aplicació que apareixen als registres.",
    access_accountability_anchoring: "Ancoratge evident de manipulació del registre d'accés a una cadena hash. Necessari per a la integritat de la pista d'auditoria de VN Cybersecurity Law.",
    access_accountability_investigations: "Espai de treball de casos per investigar esdeveniments d'accés sospitosos. Cronologia, registres enllaçats, paquets de proves i flux de treball de tancament de casos en una vista.",
    assessment_triggers: "Les regles que obren automàticament un DPIA o una presentació d'expedients quan els canvis amunt (activitat de processament nova, proveïdor nou, flux transfronterer nou) compleixen la condició d'activació.",
    connectors_gap_register: "Catàleg de connectors no implementats o parcials. Triatge d'elements, assignació de propietaris, seguiment del tancament de la bretxa sobre el full de ruta.",
    connectors_system_inventory: 'Inventari de tots els sistemes accessibles mitjançant un connector. Font única de veritat per al mapa de dades.',
    connectors_traceability: "Llinatge d'extrem a extrem d'un element de dades a través de sistemes connectats mitjançant connectors. Essencial per a la precisió de ROPA i el compliment de la sol·licitud d'assumpte.",
    consent_properties_change_requests: 'Canalització de canvis proposats a una propietat de consentiment (propòsit afegit, nou idioma, enllaç de política actualitzat). Revisió del govern abans del llançament de la producció.',
    consent_properties_comparison: "Comparació paral·lela de la forma de la propietat del consentiment entre dominis o desplegaments. Banderes a la deriva que debilitarien l'execució.",
    governance_playbooks: 'Plantilles de llibre de jocs que impulsen fluxos de treball de govern repetibles (incorporació de proveïdors, revisió de DPA, avaluació de la transferència).',
    incident_ops_coordination: 'Tauler de coordinació entre equips per a un incident actiu. Un lloc per veure qui hi ha, què estan fent i què està bloquejat.',
    incident_ops_escalation: "Registre d'escalada d'incidències actives. Les transicions de gravetat, les notificacions de les parts interessades i els resums executius es registren aquí.",
    incident_ops_post_review: "Revisió posterior a l'incident: anàlisi de la causa arrel, cronologia, accions de reparació i lliçons apreses. S'alimenta de la formació i les actualitzacions del llibre de jugades.",
    incident_ops_regulator_exports: "Generar paquets d'enviament del regulador per a incidències notificables. Mẫu số 08 (incompliment) + paquet de proves de suport.",
    incident_ops_vendor_coordination: "Coordinar la resposta amb el proveïdor el sistema del qual s'ha infringit. Obligacions contractuals, SLA de resposta i cadena d'evidència compartida.",
    monitoring_authority_readiness: "Llista de verificació de preparació i paquet d'evidències per a les properes visites del regulador. Visió consolidada dels buits pendents i controls completats.",
    monitoring_change_review: 'Revisió periòdica dels canvis de control al llarg del programa de seguiment. Detecta la deriva abans que es converteixi en una bretxa de compliment.',
    monitoring_framework_link: "Vincular els controls de seguiment a articles específics del marc normatiu. Genera el mapa d'evidències que els reguladors esperen.",
    monitoring_ric: 'Consulta normativa i casos de correspondència. Feu un seguiment de les preguntes i respostes del regulador al llarg del temps.',
    forms: 'Catàleg de formularis normatius, emplenat de formularis, instàncies de formulari i enllaços de presentació de casos. Backbone per a Mẫu số 02a/02b i enviaments relacionats.',
    monitoring_tasks: "Cua de tasques de supervisió: verificacions de control programades, certificacions i actualitzacions d'evidències.",
    partner_workspace_reports: 'Informes compartits a través de la xarxa de socis: estat de compliment, resums mensuals, mètriques entre organitzacions.',
    partner_workspace_tickets: 'Bitllets de suport recollits entre socis sobre fluxos de treball compartits i escalades.',
    program_governance_audit_readiness: "Puntuació de la preparació per a l'auditoria amb l'exploració de les proves que falten, el registre de buits i els propietaris de correccions.",
    program_governance_drafting: "Espai de treball de redacció de documents amb versions, encaminament de revisió i flux de treball d'aprovació.",
    program_governance_evidence_gaps: "Registre de buits d'evidència: que controla manca d'evidència actual i quan s'ha d'actualitzar.",
    program_governance_executive_summaries: 'Plantilles de resum executiu amb KPIs emplenats automàticament per a reunions de consells i executius.',
    program_governance_health: 'Tauler general de salut del programa: indicadors de maduresa, cobertura i tendències.',
    program_governance_issuance: "Flux de treball d'emissió de documents: aprovació, publicació, notificació a les parts interessades.",
    program_governance_model: 'Model de funcionament de govern: rols, responsabilitats, comitès i drets de decisió.',
    program_governance_remediation: 'Plans de reparació vinculats a les llacunes identificades. Propietari, termini, estat i evidència de verificació.',
    program_governance_review_cadence: 'Cadència de revisió programada per a artefactes de govern: polítiques, procediments, controls, proves.',
    program_governance_trends: "Tauler de tendències: maduresa al llarg del temps, frescor de l'evidència, velocitat de tancament de buits.",
    task_management_conflicts: 'Detecteu les assignacions de tasques conflictives (propietaris amb reserves dobles, terminis superposats) i resoleu-les mitjançant la reassignació.',
    task_management_consolidation: 'Consolideu les tasques generades automàticament per diversos mòduls en un sol flux de treball per al cessionari.',
    localization_dashboard: 'Visió general del mòdul de localització: estat del catàleg del marc, estat del paquet, cobertura de traducció i actualitzacions normatives pendents en un tauler.',
    localization_frameworks: 'Catàleg de marc normatiu: PDPL, Decret 13/2023, Decret 356/2025, Llei de ciberseguretat i GDPR. Cada marc enllaça articles amb controls de plataforma.',
    localization_framework_channels: "Canals d'enviament del regulador enllaçats a cada marc (MPS portal, MIC punt final, correu electrònic de l'autoritat). Impulsa l'encaminament de les presentacions Mẫu số.",
    localization_framework_detail: "Vista detallada d'un marc únic: articles, procediments, persones, formularis enllaçats i profunditat d'implementació a tota la plataforma.",
    localization_framework_module_links: "Marc → mapa de cobertura del mòdul. Quins articles reguladors s'aplicaran a quin mòdul de plataforma.",
    localization_language_packs: "Catàleg de paquets d'idiomes en 16 configuracions regionals: estat d'instal·lació, traducció completa i historial d'enviament de paquets.",
    localization_audit: "Pista d'auditoria dels canvis de localització: edicions del marc, actualitzacions de paquets, esdeveniments d'enviament.",
    localization_market_packs: "Marc d'agrupació de catàlegs de paquets de mercat + idioma + formularis per mercat (VN, estats membres de la UE, etc.).",
    localization_module_mappings: "Registre de mapatge de mòduls: quin article del marc s'aplica a quin mòdul al nivell de funció.",
    localization_pack_detail: "Vista detallada del paquet únic: versió, marcs inclosos, estat de traducció, historial d'instal·lació.",
    localization_pack_submissions: "Canal d'enviament de paquets: enviaments de socis, estats de revisió, aprovacions de publicacions.",
    localization_regulatory_updates: "Font d'actualització normativa: nous decrets, modificacions i orientacions que afecten el catàleg marc.",
    localization_sector_overlays: "Catàleg de superposició sectorial: paquets de regulació opcionals específics del sector (p. ex., banca, sanitat). Instal·leu-lo en mode directe per a organitzacions dins de l'abast o en mode de referència per a la visibilitat entre sectors.",
    localization_help_content_packs: "Gestor de paquets de contingut d'ajuda: instal·leu, versioneu i traduïu els articles d'ajuda de l'aplicació, les guies de mòduls i els inicis ràpids que apareixen a la interfície d'usuari d'administració.",
    localization_translation_preview: "Previsualització en directe de les cadenes de la interfície d'usuari en diferents configuracions regionals. Comparació paral·lela per al control de qualitat de la traducció.",
    organizations_groups_create: "Creeu un nou grup d'organització (koncern): seleccioneu l'organització root, seleccioneu membres, definiu el mode d'herència per categoria.",
    organizations_groups_detail: "Detall del grup d'organització únic: membres, matriu d'herència, recursos compartits i resum d'auditoria.",
    organizations_groups_settings: "Configuració del grup organitzatiu: SLA, calendari, notificacions, ingesta, integració de CMP. Canvi d'herència/anul·lació per categoria.",
    organizations_groups_audit: "Registre d'auditoria per grup: canvis de pertinença, canvis d'herència, afegeix/eliminació de recursos compartits.",
    organizations_groups_consolidated_audit: "Visualització d'auditoria consolidada a totes les organitzacions membres d'un grup. Filtra per entitat, actor, finestra de temps.",
    organizations_groups_dashboard: 'Tauler de control entre membres: estat del compliment, elements oberts, SLA incompliments acumulats per a tot el grup.',
    organizations_groups_reports: 'Informes a nivell de grup: resum executiu, resum per a reguladors, comparació de KPI entre membres.',
    organizations_groups_users: 'Usuaris visibles a tot el grup: assignacions de funcions entre organitzacions, administradors compartits, cadena de suplantació.',
    organizations_groups_merged_vendors: 'Visualització de proveïdors desduplicats a les organitzacions membres: un únic venedor apareix una vegada encara que estigui integrat per separat.',
    organizations_groups_shared_templates: 'Plantilles de formularis publicades a nivell de grup. Els membres opten per heretar una plantilla; la desactivació és per organització.',
    organizations_groups_shared_frameworks: "Marcs normatius compartits a tot el grup. L'actualització central flueix a tots els membres amb mode=inherit.",
    organizations_groups_shared_vendors: 'Registre de proveïdors a nivell de grup. Contracte, estat de DPA i puntuació de risc visibles per a tots els membres.',
    onboarding_help_center: "Centre d'ajuda: explora els més de 309 articles per mòdul, categoria i persona. Cerca de text complet en contingut EN + VI.",
    onboarding_progress: "Seguiment del progrés d'incorporació: quins passos de posada en marxa s'han completat, quins estan pendents, qui és el propietari dels bloquejadors.",
    onboarding_personas: 'Persona Paths: find your role among every role available to your organisation, starting with the roles your installed frameworks name. Open a role to see the frameworks that name it, the registers it works in, its quick start and use cases, and save it as your onboarding persona.',
    onboarding_quick_starts: "Escenaris d'inici ràpid: executeu un flux de treball de compliment complet d'extrem a extrem a la caixa de proves. Ideal per entrenar.",
    onboarding_sample_data: 'Generador de dades de mostra: carregueu files de demostració realistes a qualsevol mòdul. Útil per a demostracions de vendes i formació.',
    onboarding_tours: 'Visites guiades interactives. Inicieu una guia específica del mòdul que narra cada pàgina mentre navegueu.',
    security_sessions: 'Visualització en directe de les sessions autenticades: dispositiu, IP, darrera activitat, factor MFA utilitzat. Acaba amb un clic.',
    security_api_keys: "API claus del compte de servei: abast, rotació, darrer ús i pista d'auditoria per clau.",
    security_break_glass: "Accés de trencament de vidre d'emergència: subvenció superadministrativa limitada en el temps amb pista d'auditoria obligatòria i revisió posterior a l'esdeveniment.",
    security_delegations: 'Lend another member some or all of your own permissions for a fixed window. They hold them from the start until the end or until you revoke, checked on every request, and each use is recorded in the security audit trail.',
    security_ip_allowlist: "Configuració de la llista d'IP: restringeix l'inici de sessió de l'administrador a xarxes corporatives específiques o rangs VPN.",
    security_mfa: "Política d'autenticació multifactorial: aplicació per rol, llista de factors permesos (TOTP/SMS/WebAuthn), flux de restabliment.",
    security_service_accounts: "Comptes de servei per a la integració de sistema a sistema. L'abast, auditat i rotat per separat dels usuaris humans.",
    security_session_settings: "Política de sessió: temps d'espera d'inactivitat, edat màxima de la sessió, límit de sessions concurrents, activadors de re-autenticació.",
    security_sso: "Configuració d'inici de sessió únic: proveïdors SAML/OIDC, mapes d'atributs, regles d'aprovisionament automàtic.",
    rights_requests_create: "Creeu un nou cas de sol·licitud de drets dels subjectes de dades. Captura la identitat del sol·licitant, el tipus de sol·licitud, el canal i l'inici del rellotge SLA.",
    rights_requests_list: 'Tots els casos de sol·licitud de drets amb SLA compte enrere, assignat, estat i xips de filtre per a canal + tipus de sol·licitud.',
    rights_requests_detail: 'Espai de treball de cas únic: correspondència, accions de compliment, proves, redacció de respostes, SLA transicions.',
    rights_requests_cmp_sync: "CMP configuració de sincronització d'integració: punt final de webhook, regles de creació de casos automàtics, política de reintentar.",
    rights_requests_extensions: "SLA sol·licituds d'extensió: justificació, encaminament de l'aprovador i entrada de pista d'auditoria en atorgar o rebutjar.",
    rights_requests_fulfillment: 'Espai de treball de sol·licitud de compliment: recopilació de paquets de dades, aplicació de redaccions, paquet per al lliurament.',
    rights_requests_responses: "Redacció de respostes amb inserció de plantilles, camps de combinació i vista prèvia d'EN/VI al costat de l'altre.",
    rights_requests_response_templates: 'Catàleg de plantilles de resposta: plantilles aprovades per tipus de sol·licitud + jurisdicció, amb historial de versions.',
    compliance_forms_consolidation_create: 'Creeu un nou cas de consolidació: agrupa els enviaments de formularis relacionats amb un sol paquet de presentació destinat a un regulador.',
    compliance_forms_consolidation_detail: 'Espai de treball de cas de consolidació únic: entrades de la secció, aprovacions dels revisors, exportació del dossier complet al regulador.',
    compliance_forms_consolidation_cases: 'Tots els casos de consolidació amb estat de presentació, assignacions de revisors i seguiment de terminis.',
    compliance_forms_consolidation_review: "Reviseu l'espai de treball per a casos de consolidació: aproveu les entrades de la secció, sol·liciteu revisions, tanqueu la sessió abans de l'exportació.",
    compliance_forms_dossier_export: "Exporteu l'expedient consolidat com a paquet PDF preparat per als reguladors amb carta de presentació, annexos i signatures.",
    compliance_forms_section_input: "Espai de treball del propietari del departament per completar una única secció d'un cas de consolidació.",
    compliance_forms_filing_case_links: 'Vincles entre instàncies de formulari i casos de presentació. Assegura que cada presentació està avalada per les dades del formulari adequades.',
    compliance_forms_section_routing: "Regles d'encaminament de seccions: quin departament és propietari de quina secció de cada plantilla de formulari.",
    assessments_dashboard: "Tauler d'avaluacions: recompte de DPIA, avaluacions de transferència, resum de mancances, properes dates límit de revisió.",
    assessments_dossier_filing_detail: "Presentació d'un sol dossier: tipus de formulari (Mẫu số 02a/02b), assignacions de la secció, estat de la secció, detalls de l'enviament, temporitzadors MPS.",
    assessments_dossier_filing_list: "Tots els expedients amb tipus de formulari, estat i progrés de l'assignació de seccions. Filtra per estat i marc.",
    assessments_dpia_list: "Registre DPIA: totes les avaluacions d'impacte de protecció de dades en curs, aprovades i arxivades.",
    assessments_gap_report: "Informe de bretxa: cobertura de DPIA, requisit de DPIA no classificat, riscos no mitigats, faltes de presentació. Superfície primària de preparació per a l'auditoria.",
    assessments_transfer_list: 'Avaluacions de transferència per a fluxos de dades transfronterers. Cada avaluació documenta el mecanisme, les garanties i la qualificació de risc.',
    deletion_orchestration_templates: "Plantilles de llista de verificació per a les execucions d'eliminació. Cada plantilla és una seqüència de tasques amb guió lligades a sistemes i regles de retenció específics.",
    deletion_orchestration_dsr_integration: "Integració de DSR a supressió: activa automàticament una execució de supressió a partir d'una sol·licitud d'esborrament aprovada.",
    deletion_orchestration_tasks: "Tasques d'execució d'execucions de supressió activa. Cada tasca fa un seguiment del sistema, l'acció, el propietari i les proves de verificació.",
    deletion_orchestration_dashboard: "Tauler d'orquestració de supressió: execucions actives, percentatge de finalització, verificacions pendents, actualització de la cadena de proves.",
    deletion_orchestration_proof_chain: "Cadena de prova de manipulació per a cada acció d'eliminació. Necessari per al compliment de l'PDPL en esborrar.",
    organizations_compliance_rollup: 'Agrupació de compliment entre entitats: KPI per entitat, cobertura a nivell de marc, obligacions pendents.',
    organizations_departments_admin: "Espai de treball d'administració per a departaments: crear, reassignar propietaris, gestionar la pertinença a l'equip, establir regles d'encaminament.",
    organizations_departments: "Llista de departaments entre entitats. Impulsa l'encaminament de la secció, els fluxos d'aprovació i l'atribució d'evidències.",
    organizations_entity_frameworks: "Assignar marcs normatius a cada entitat. Unitats als quals s'apliquen els formularis Mẫu số i quines auditories són obligatòries.",
    organizations_entity_form: "Creeu o editeu una única entitat d'organització: nom legal, registre de l'empresa, adreça, representant.",
    organizations_list: "Totes les entitats organitzatives del llogater. Vista de llista principal amb filtres d'estat i accions d'accés ràpid.",
    organizations_retention_policies_admin: "Administració de polítiques de retenció a l'abast de l'organització: regles per defecte, substitucions per entitat.",
    task_management_calendar: 'Visualització del calendari de tasques i terminis. Codificat per colors per mòdul i estat SLA.',
    task_management_my_tasks: "Cua de tasques personals: m'han assignat, vencerà aviat, vençut. Espai de treball diari principal.",
    task_management_overdue: "Tasques vençudes a tota l'organització. Filtra per propietari, mòdul i grup de dies de venciment.",
    task_management_section_assignments: "Visió general de l'assignació de la secció: quin departament és propietari de quina secció de cada presentació de formularis actiu.",
    task_management_board: "Vista del tauler Kanban de les tasques. Arrossegueu entre columnes (Fer / En curs / Revisar / Fet) per actualitzar l'estat.",
    task_management_detail: "Espai de treball d'una única tasca: descripció, comentaris, fitxers adjunts, subtasques, pista d'auditoria, transicions d'estat.",
    task_management_list: 'Llista plana de totes les tasques amb filtres: propietari, mòdul, estat, prioritat, interval de terminis.',
    consent_cmp_sync: "CMP espai de treball de sincronització: activar sincronitzacions, revisar l'historial de sincronització, inspeccionar errors. Manté l'estat CMP alineat amb la plataforma.",
    consent_cmp_bulk_sync: "Sincronització massiva de CMP: torna a sincronitzar tots els registres de consentiment a totes les propietats. S'utilitza per a migracions d'inquilins i grans CMP canvis.",
    consent_cmp_integration: "CMP configuració d'integració: punt final, autenticació, política de sincronització i estat de connexió.",
    consent_cmp_purpose_mapping: 'Assigna els propòsits CMP als propòsits de la plataforma. Assegura que els senyals de consentiment flueixen correctament entre els dos sistemes.',
    consent_cmp_webhook: "CMP webhook Configuració: encaminament d'esdeveniments entrants, secrets de signatura, política de reintents.",
    partner_workspace_brand_profiles: 'Perfils de marques de socis: logotip, eslogan, contacte, ofertes de serveis. Impulsa la llista del mercat de socis.',
    partner_workspace_deliverable_templates: 'Catàleg de plantilles de lliurament: paquets de serveis estandarditzats que els socis poden oferir (DPIA revisió, auditoria de proveïdors, formació).',
    partner_workspace_deliverables: "Productes actius en els compromisos dels socis. L'abast del seguiment, les dates de venciment, els criteris d'acceptació.",
    partner_workspace_service_tiers: 'Definicions dels nivells de servei: bronze/plata/or amb abast, SLA i bandes de preus.',
    partner_workspace_workflow_instances: 'Instàncies actives de flux de treball entre els socis: incorporació, revisió, escalada, execucions de baixa.',
    partner_workspace_workflow_templates: 'Catàleg de plantilles de flux de treball per a compromisos de socis. Cada plantilla defineix passos, propietaris, SLA i sortides.',
    access_accountability_justification_reviews: "Revisar les justificacions d'accés presentades pels usuaris. Aprovar, desafiar o augmentar la política per zona.",
    access_accountability_review_campaigns: "Campanyes d'accés-revisió programades: recurrència, abast, assignació de revisors, seguiment de finalització.",
    access_reviews_list: "Totes les campanyes d'accés-revisió amb filtres: cicle, estat, revisor, sistema objectiu.",
    access_reviews_campaign_detail: "Espai de treball de campanya única: abast, revisors, cua d'articles, estat de certificació, pista d'auditoria.",
    access_reviews_my_reviews: "Revisions que m'han assignat: decisions pendents amb context, certificar o revocar per article.",
    attestation_schedules_list: "Registre de calendari d'acreditació: recurrència, abast, data de venciment següent, percentatge de finalització per programa.",
    attestation_schedules_create: "Creeu un nou calendari d'acreditació: seleccioneu la freqüència, l'abast, els certificats i els requisits d'evidència.",
    attestation_schedules_edit: "Editeu una programació de certificació existent. Els canvis s'apliquen al cicle següent; els cicles passats romanen sense canvis.",
    attestation_schedules_history: "Cronologia històrica de finalització d'un calendari d'acreditació. Evidència d'artefactes vinculats per cicle.",
    governance_board_report: 'Informe de compliment preparat per al consell: resum executiu, tendències de la puntuació, riscos pendents, estat de correcció.',
    governance_compliance_score: 'Càlcul de la puntuació de compliment entre marcs. Aprofundir en la contribució per control.',
    governance_drift_monitor: 'Detecta la deriva del control: canvis de configuració, concessió de permisos, excepcions de polítiques que debiliten la postura.',
    governance_audit: "Registre d'auditoria específic del govern: esdeveniments de flux de treball, decisions d'aprovació, senyals de deriva.",
    governance_evidence: "Catàleg d'evidències per als controls de govern. Documents de suport, captures de pantalla, rebuts de certificació.",
    partner_workspace_escalation: "Tauler d'escalada entre socis: escalades obertes, gravetat, rellotges SLA i propietaris de la propera acció.",
    partner_workspace_audit: "Registre d'auditoria per a l'espai de treball dels socis: canvis de participació, actualitzacions de lliurament, transicions d'escalada.",
    partner_workspace_partner_detail: "Perfil de l'organització d'un únic soci: historial de participació, resultats actius, contactes, puntuació de rendiment.",
    partner_workspace_partner_list: "Registre d'organitzacions associades: socis actius, incorporats i fora de bord amb insígnies de nivell de servei + rendiment.",
    platform_license: 'Configuració de la llicència: nivell, recomptes de seients, estat de renovació, canvis de funcions impulsats per la llicència instal·lada.',
    platform_notifications_admin_queue: "Cua de notificacions de l'administrador: alertes durant el vol, errors de lliurament, estat de reintent a través dels canals de correu electrònic/SMS/in-app.",
    platform_notifications_prefs: 'Preferències de notificació per usuari: activació del canal, programació de resum, temes silenciats.',
    settings_overview: 'Visió general de la configuració dels inquilins: enllaços ràpids a dominis, correu electrònic, exportacions, webhooks i altres configuracions de tota la plataforma.',
    settings_domains: 'Dominis permesos per al registre i SSO. Restringeix la creació de comptes als dominis corporatius verificats.',
    settings_email: 'Configuració del correu electrònic de sortida: proveïdor SMTP, identitat del remitent, estat DKIM/SPF, eina de prova de correu electrònic.',
    settings_export_schedules: 'Exportacions programades: generació recurrent CSV/XLSX/PDF lliurada al navegador de fitxers en una programació cron.',
    settings_webhooks: 'Punts finals de webhook de sortida: subscriu sistemes externs als esdeveniments de la plataforma. Signatura, reintent i auditoria de cada lliurament.',
    sod_rules_create: "Creeu una regla de segregació de funcions: seleccioneu parells de rols conflictius, abast i mode d'aplicació (bloquejar/avisar).",
    sod_rules_edit: 'Editeu una regla de SoD existent. Els canvis tenen efecte immediatament; les infraccions existents es tornen a avaluar en el proper accés.',
    sod_rules_list: "Totes les regles de SoD a tot l'arrendatari: mode d'aplicació, parells de rols, recompte d'excepcions, recompte d'infraccions.",
    connectors_definitions: 'Registre de tipus de connector: definició de cada integració (forma del punt final, autenticació, operacions suportades).',
    connectors_list: "Totes les instàncies del connector connectades a l'arrendatari. Estat, darrera sincronització, registre d'errors, acció de sincronització sota demanda.",
    connectors_credentials: 'Volta de credencials del connector: OAuth fitxes, API claus, contrasenyes de compte de servei. Calendari de rotació + auditoria.',
    connectors_event_bus: "Bus d'esdeveniments del connector: esdeveniments entrants d'integracions, regles d'encaminament, reproducció de la cua de missatges no enviats.",
    consent_change_awareness: 'Detectar canvis significatius de consentiment: propòsit afegit, política actualitzada, abast ampliat. Impulsa campanyes de reconsentiment.',
    consent_audit: "Pista d'auditoria de consentiment: cada subvenció, actualització, retirada dels fluxos de treball. Superfície primària per a les visites del regulador.",
    consent_reconciliation: "Reconcilieu l'estat del consentiment entre CMP, la plataforma i els sistemes aigües avall. Senyala discrepàncies.",
    consent_withdrawal_propagation: 'Canal de propagació de la retirada: quan un subjecte retira el consentiment, assegureu-vos que flueixi a tots els sistemes enllaçats.',
    consent_policies: "Catàleg de polítiques de consentiment: versions de polítiques de privadesa, variants d'idioma, finestres d'activació.",
    consent_purpose_catalog: 'Catàleg de finalitats utilitzat pels fluxos de treball de consentiment. Cada propòsit enllaça amb una base legal i una regla de retenció.',
    consent_snapshots: 'Instantània de consentiment: captura puntual de tots els consentiments actius. Necessari per a auditories i retencions legals.',
    consent_workflows: 'Catàleg de flux de treball de consentiment. Cada flux de treball defineix activadors, fluxos de recollida i accions posteriors.',
    discovery_classification_lineage: 'Llinatge de classificació: rastreja com es va classificar un element de dades mitjançant escanejos i revisió manual.',
    discovery_classification_rules: 'Registre de regles de classificació: expressions regulars, vocabulari, patrons ML utilitzats per classificar automàticament els camps descoberts.',
    discovery_dedup_rules: 'Regles de deduplicació per a registres descoberts. Evita que el mateix camp aparegui diverses vegades.',
    discovery_import_templates: 'Importeu plantilles per incorporar catàlegs de dades existents al mòdul Discovery mitjançant CSV o eines externes.',
    discovery_owner_review: "Cua de revisió del propietari: classificacions suggerides que esperen l'aprovació o el rebuig del propietari de les dades.",
    discovery_staging: "Zona d'escenificació de camps recentment descoberts. Triatge abans de la promoció al catàleg de mapes de dades.",
    discovery_suggestion_analytics: 'Analítica per al motor de suggeriments: precisió, cobertura, classificacions més anul·lades.',
    discovery_suggestion_queue: "Reviseu la cua de classificacions suggerides abans d'aplicar-les. Acceptar, modificar o rebutjar per element.",
    compliance_forms_filler: 'Emplenament de formularis interactiu: passeu per un formulari regulador amb validació, desat automàtic i suport de coautor.',
    compliance_forms_instance_detail: 'Instància de forma única: estat actual, historial, expedient enllaçat, exportacions.',
    compliance_forms_outputs: 'Sortides generades per instància de formulari: PDF, DOCX, JSON paquets amb carta de presentació i signatures.',
    compliance_forms_submission_packages: "Catàleg de paquets d'enviament: paquets preparats per als reguladors amb manifest, signatures i rebut de lliurament.",
    incident_ops_regulatory_sla: "Configuració normativa SLA per a les notificacions d'incidències (VN Cybersecurity Law 72 hores, PDPL 72 hores, GDPR 72 hores).",
    incident_ops_response_metrics: "Mètriques de resposta a incidents: MTTD, MTTR, SLA percentatge de compliment, recomptes d'escalada.",
    incident_ops_sla_dashboard: "Tauler de control SLA: incidents actius contra el seu rellotge SLA, avisos de risc, historial d'incompliments.",
    incident_ops_sla_definitions: 'SLA definicions: nivells de gravetat, finestres de resolució i resposta per nivell, cites del marc.',
    monitoring_governance_raci: 'Matriu RACI per als controls de govern: responsable, responsable, consultat, informat per control en tot el programa.',
    monitoring_periods: 'Períodes de seguiment: cicles de revisió anual/trimestral/mensual alineats a les finestres de presentació de la normativa.',
    monitoring_programs_list: 'Catàleg de programes de seguiment: programes alineats amb el marc amb abast, propietari, cadència.',
    monitoring_task_templates: "Plantilles de tasques per a cicles de seguiment. Cada plantilla defineix l'abast, la funció del cessionari i els requisits d'evidència.",
    access_accountability_evidence_detail: "Detall del paquet d'evidència únic: cadena de custòdia, signatures, opcions d'exportació per a la presentació del regulador.",
    access_accountability_evidence_packages: "Catàleg de paquets d'evidència per a l'accés i la responsabilitat: paquets signats i a prova de manipulació preparats per a l'auditoria.",
    access_reviews_role_analytics: "Anàlisi de rols: densitat d'ús de rols, fluïdesa dels drets, tendències de decisió de certificació.",
    access_accountability_pattern_analysis: "Anàlisi de patrons dels registres d'accés: temps d'accés inusuals, valors atípics geogràfics, senyals d'escalada de privilegis.",
    access_accountability_session_dashboard: 'Tauler de sessió: sessions autenticades en directe, mapa de calor de sessió per hora/dia, alertes de sessió inactiva.',
    classification_exports: "Exportacions de classificació: exporteu l'inventari de classificació com a CSV/XLSX per a eines d'auditoria externa.",
    classification_discovery_cycles: 'Cicles de descobriment de classificació: exploracions programades que afloren elements de dades recentment afegits o modificats.',
    classification_enterprise_data_map: 'Mapa de dades empresarials: vista de classificació agregada entre sistemes, departaments i nivells de sensibilitat.',
    connectors_automation_planning: "Planificació de l'automatització: definiu activador → connector → cadenes d'acció per a operacions de dades basades en esdeveniments.",
    connectors_brd_capture: 'Requisits empresarials Captura de documents per a noves instal·lacions de connectors.',
    connectors_poc_scorecards: "Quadres de control de prova de concepte per avaluar les integracions de nous connectors en funció dels criteris d'acceptació.",
    discovery_connector_management: 'Gestió del connector de descoberta: quins escàners estan instal·lats, el seu estat i a quins sistemes es dirigeixen.',
    discovery_scans_list: 'Totes les exploracions de descoberta amb estat, cobertura i descobriments. Explora les troballes per exploració.',
    governance_approvals: 'Governance approvals register: requests recorded for vendor, cross-border, playbook and drift decisions, with who decided each and why. A request is decided by someone other than the person who made it.',
    governance_offboarding: "Flux de treball d'exclusió del proveïdor: rescissió del contracte, devolució/supressió de dades, revocació d'accés, auditoria final.",
    governance_periodic_review: 'Revisió periòdica del proveïdor: reavaluació programada del risc, moneda DPA, llista de subprocessadors.',
    incident_ops_playbook_activations: "Instàncies actives del llibre de jugades: quin llibre de jocs s'està executant en quin incident, progrés, tasques pendents.",
    incident_ops_playbook_links: "Playbook → registre d'enllaços d'incidències. També enllaça a plantilles de notificació del regulador per llibre de jugades.",
    incident_ops_playbook_templates: "Catàleg de plantilles del llibre de jocs: scripts de resposta a incidents reutilitzables per tipus i gravetat d'incident.",
    organizations_groups_settings_inheritance: "Configuració de la matriu d'herència entre els membres del grup. Canvi d'herència/anul·lació per categoria amb pista d'auditoria.",
    organizations_intake_config_form: "Creeu o editeu una configuració d'ingrés: camí URL de forma pública, límits de velocitat, captcha, encaminament de notificacions.",
    organizations_intake_configs_list: "Catàleg de configuració d'admissió: punts d'entrada de sol·licitud de drets públics per mercat/marca.",
    privacy_scanner_monitoring_dashboard: "Tauler de control de l'escàner de privadesa: cobertura de la propietat, cadència d'escaneig, senyals marcats per propietat.",
    privacy_scanner_monitoring_settings: "Configuració de monitorització: freqüència d'exploració, regles de llindar, encaminament d'alerta, retenció dels resultats de l'escaneig.",
    privacy_scanner_settings: "Configuració de l'escàner: categories d'escaneig activades, actualitzacions de signatura, AesirX credencials del punt final de l'escàner.",
    privacy_scanner_real_time_scan: 'Escaneig en temps real: activeu una exploració ad-hoc i mireu els resultats en flux. Ideal per a una verificació ràpida.',
    privacy_scanner_scan_result_detail: "Vista detallada d'un únic resultat d'exploració: galetes, balises, rastrejadors trobats, classificació, accions de correcció.",
    privacy_scanner_results_archive: "Arxiu de resultats de l'exploració històrica. Filtra per propietat, interval de dates, tipus de senyal.",
    task_management_workflow_detail: 'Instància de flux de treball única: tots els passos, propietaris, SLA, lògica de ramificació, proves de finalització.',
    task_management_workflow_list: "Totes les instàncies de flux de treball entre mòduls: estat, propietari, data límit, mòdul d'origen.",
    task_management_workflow_templates: 'Catàleg de plantilles de flux de treball: fluxos de treball de diversos passos reutilitzables que es poden instanciar des de qualsevol mòdul font.',
    audit_trail_classic: "Visualització clàssica de la pista d'auditoria (heretat). Quedant obsolet a favor del mòdul d'auditoria unificada.",
    audit_trail_unified: "Pista d'auditoria unificada a cada mòdul. Superfície d'auditoria primària.",
    iat_settings: 'Configureu el complement de pistes d\'auditoria immutables: activació, abast, mode de prova predeterminat, substitucions de taxonomia, majúscules i rotació de credencials AesirX. Llegiu primer la guia del mòdul canònic; el company profund és "Activació i configuració".',
    iat_status: 'Navega per cada proof_link amb filtres d\'estat, mode, mòdul i data. Feu clic a qualsevol insígnia per obrir el calaix de proves. Acompanyament profund: "Entendre l\'estat de la prova".',
    iat_integrity_center: "Executeu passades de verificació de detecció de deriva durant un interval de dates; exporteu el paquet d'integritat per a qualsevol àmbit d'auditoria. Acompanyament profund: \"Utilitzar el Centre d'Integritat\".",
    iat_usage: 'Feu un seguiment del saldo actual, del consum mensual, de l\'estat del límit i bescanvieu paquets de crèdit. Acompanyament profund: "Crèdits i Caps".',
    classification_exceptions: "Cua d'excepcions de classificació: registres marcats com a casos extrems, en espera de revisió manual.",
    classification_review_tasks: "Cua de tasques de revisió de classificació: classificacions suggerides automàticament a l'espera de la confirmació del propietari.",
    consent_properties_audit_log: "Pista d'auditoria dels canvis de propietat del consentiment: qui ha actualitzat què, quan, valors antics/nous.",
    consent_properties_analytics: 'Anàlisi de la propietat del consentiment: taxa de captura de consentiment, taxa de retirada, tendències de la barreja de propòsits.',
    consent_properties_evidence_packs: "Paquets d'evidència per a propietats de consentiment: paquets preparats per als reguladors que demostren el compliment de la captura de consentiment.",
    consent_properties_inconsistencies: "Incoherències de la propietat del consentiment: propietats en què la plataforma i CMP no estan d'acord en l'estat.",
    consent_properties_golden_templates: "Plantilles de bàners de consentiment d'or: formes de bàners aprovades, revisades i preparades per a la governança desplegades a totes les propietats.",
    consent_properties_template_rollouts: 'Canal de llançament de plantilles: fase, pilot, onades de producció per impulsar plantilles daurades a les propietats.',
    consent_properties_property_groups: 'Grups de propietats: propietats relacionades amb el clúster per a la governança i els informes acumulats.',
    consent_properties_snapshot_schedules: "Programes d'instantànies: automatitzeu les captures periòdiques de l'estat del consentiment amb finalitats d'auditoria i retenció legal.",
    deletion_orchestration_completeness: "Seguidor d'exhaustivitat: verifica la supressió confirmada de tots els sistemes de l'àmbit de retenció.",
    deletion_orchestration_runs_list: "Totes les execucions d'eliminació: estat, durada, sistemes coberts, percentatge de finalització.",
    deletion_orchestration_vendor_requests: 'Sol·licituds de supressió de sortida als venedors: seguiment, SLA, artefactes de verificació.',
    deletion_orchestration_vendor_verification: "Flux de treball de verificació del proveïdor: confirmeu que els sistemes del proveïdor han completat l'esborrat segons la nostra sol·licitud.",
    compliance_forms_catalog: 'Catàleg de formularis de compliment: tots els formularis normatius (GDPR Art 30, ISO 27701) disponibles per a la presentació.',
    compliance_forms_template_browser: 'Navegador de plantilles: descobreix plantilles de formularis aprovades a través dels marcs.',
    governance_cross_border: 'Registre de transferències transfrontereres a nivell de govern: mecanismes, salvaguardes, avaluació del risc país.',
    governance_subprocessors: 'Registre del subprocessador: qui utilitzen els nostres venedors, cascada DPA, notificació de canvis.',
    incidents_detail: "Espai de treball d'incident únic: cronologia, propietari, gravetat, correcció, estat de notificació del regulador.",
    incidents_list: "Registre d'incidències: totes les incidències actives + històriques amb filtres de gravetat, canal, marc.",
    partner_workspace_partner_dashboard: "Tauler de control de partners: KPI de primer nivell per a tots els compromisos de partners, recomptes d'escalada, tendència de salut.",
    partner_workspace_support_tickets: "Catàleg de bitllets d'assistència per a socis. Compartit entre equips de socis i inquilins amb el seguiment de SLA.",
    program_governance_acknowledgment_tracking: 'Seguiment del reconeixement del document: qui ha llegit i reconegut cada política o procediment.',
    program_governance_change_log: "Registre de canvis de documents: cada edició d'un document de govern amb diferencia i cadena d'aprovació.",
    roles_detail: 'Detall del rol únic: permisos vinculats a aquest rol, usuaris assignats, auditoria dels canvis de pertinença.',
    roles_list: "Catàleg de rols: tots els rols integrats i personalitzats amb el nombre de membres i l'abast de permisos.",
    consent_properties_cross_property_dashboard: "Tauler de control entre propietats: consentiu la salut a cada propietat. Taxa de captura d'agregats, taxa de retirada, indicadors de deriva.",
    consent_properties_property_registry: "Registre de la propietat: cada propietat que gestiona l'arrendatari amb el seu estat de bàner de consentiment, enllaçat CMP, versió de la política.",
    forseti_projects_overview: "Espais de treball de Forseti: un projecte agrupa documents, converses, execucions de flux de treball i ressenyes tabulars en un sol contenidor perquè l'assessor AI mantingui el context durant tot el compromís.",
    forseti_workflows_list: "Saved AI prompt templates that produce tasks and draft evidence on demand. Use built-in pack workflows or author your own; each run is sent to your organisation's configured AI provider, and what it consumed is shown on Forseti → Usage.",
    forseti_tabular_reviews_list: "Revisió repetible, columna per columna, d'un corpus de documents. Definiu les preguntes una vegada, feu la mateixa revisió en molts fitxers adjunts i obteniu una graella de respostes al costat de les cites.",
    forseti_document_review_index: "Tria la safata d'entrada dels documents amb edicions suggerides per AI o versions d'origen Forseti. Els documents entren a la cua des dels xats, les execucions del flux de treball o la CTA \"Envia un document per a la revisió\" d'aquesta pàgina.",
    forseti_audit_lineage: "Traça cada artefacte generat per AI adjunt a qualsevol registre: xats, trucades d'eines, tasques, esborranys de proves i versions de documents. Necessari per a la defensa de l'evidència i les auditories posteriors a l'acció.",
    forseti_draft_evidence: "AI-esborrany de proves pendents de revisió humana. Cada esborrany ha de ser aprovat per un revisor autoritzat abans que es converteixi en una evidència formal: Forseti mai s'archiva automàticament.",
    forseti_usage: 'What Forseti has consumed for this organisation: requests and tokens for a chosen period, broken down by provider, model, effort and feature, with the routing each feature uses now and recent activity.',
    forseti_ai_model: 'Configure the AI provider behind Forseti. Each provider card holds its own API key, model, fast model and effort, with a connection test; the general section chooses which provider is active.',
    forseti_overview: "Punt d'entrada a l'assessor legal de Forseti AI: tria una persona, consulta els xats recents i inicia una conversa nova. La selecció de persona aquí estableix la veu predeterminada per als xats nous.",
    forseti_chat_detail: "Conversa única de Forseti: visualitza l'historial de missatges, canvia de persona a la meitat del xat, envia missatges nous i exporta la transcripció com a PDF amb finalitats de proves.",
    forseti_cross_framework_conflicts: 'Catàleg seleccionat de conflictes entre els paquets reguladors que ha instal·lat la vostra organització. Filtreu per marc/tema/gravetat/estat de reconeixement, feu clic a una fila per veure les posicions del marc en paral·lel i reconèixer/assignar/resolver. Forseti aflora els conflictes; els humans decideixen.',
    users_detail: "Perfil d'usuari únic: identitat, rol, MFA, historial de sessions, pista d'auditoria.",
    users_list: "Directori d'usuaris: tots els usuaris actius, convidats i desactivats amb filtres ràpids i accions massives.",
    governance_vendors: "Gestioneu el cicle de vida del govern dels proveïdors: canal d'incorporació, revisions periòdiques, aprovacions i baixa. Feu un seguiment de l'estat de compliment del proveïdor i de l'adhesió al llibre de jocs.",
    governance_compliance: "Superviseu la postura de compliment de l'organització amb puntuació, detecció de deriva i informes de la junta. Feu un seguiment de les tendències de compliment i genereu informes preparats per a executius.",
    governance_transfers: 'Gestioneu les transferències de dades transfrontereres, les revisions de DPA i el govern del subprocessador. Documentar els mecanismes de transferència i garantir el compliment normatiu dels fluxos internacionals de dades.',
    vendor_risk_assessment: 'Avalueu i puntueu el risc del proveïdor a tota la vostra cartera. Superviseu els senyals de risc, feu un seguiment de les reavaluacions i mantingueu una visió completa de la cartera de riscos.',
    vendor_risk_contracts: 'Gestioneu els contractes de proveïdors, els qüestionaris de diligència deguda i les avaluacions de la porta. Feu un seguiment de les condicions del contracte, les dates de renovació i els requisits de compliment.',
    vendor_risk_onboarding: "Gestioneu el cicle de vida d'incorporació del proveïdor: avaluació d'admissió, encaminament de revisió, fluxos de treball d'aprovació i decisions d'acceptació de riscos.",
    vendor_risk_dashboard: "Visió general central de la postura de risc del vostre proveïdor: distribució de la cartera per nivell, canvis de nivell recents, contractes que caduquen en 90 dies, revisió dels KPI i salut de l'acceptació del risc. Comenceu aquí per obtenir una lectura d'un cop d'ull abans de perforar la puntuació, els senyals o les portes.",
    vendor_risk_scoring: "Configureu les dimensions de puntuació i avalueu els proveïdors segons criteris de risc ponderats. Feu un seguiment de les puntuacions compostes, dels nivells assignats i de l'historial de puntuacions al llarg del temps.",
    vendor_risk_signals: "Feu un seguiment dels esdeveniments adversos que poden justificar una reavaluació del proveïdor: caducitat de la certificació, notificacions d'incompliment, inestabilitat financera i canvis de compliment. Els senyals condueixen a les tasques de reavaluació aigües avall.",
    vendor_risk_reviews: "Realitzeu revisions periòdiques dels proveïdors amb instantànies de l'estat del contracte, troballes i recomanacions. Feu un seguiment dels resultats de la revisió (satisfactoris, s'identifiquen problemes, es requereixen correccions, s'han escalat) a través dels programes i períodes.",
    vendor_risk_reassessments: 'Activar i gestionar tasques de reavaluació quan els senyals o els horaris periòdics indiquen un canvi de postura de risc. Registre els resultats i els nivells de risc actualitzats; les reavaluacions completades tornen a la puntuació.',
    vendor_risk_acceptance: "Accepteu formalment el risc residual del venedor amb condicions explícites, dates de caducitat i justificació. Mantenir el registre d'acceptació de riscos: el registre auditable de les decisions d'acceptació actives, vençudes i revocades.",
    vendor_risk_onboarding_cases: "Gestioneu el cicle de vida dels casos d'incorporació del proveïdor: incorporació nova, revisions de canvis de materials i revisions periòdiques. Treballeu a través de pestanyes per fases amb indicadors de finalització i activeu les portes d'aprovació quan estigui llest.",
    vendor_risk_review_routing: "Encamineu les tasques de revisió del proveïdor a revisors específics per usuari i rol. Assigneu qüestionaris, feu un seguiment de les assignacions dels revisors i captureu els resultats de l'encaminament amb una pista d'auditoria completa.",
    vendor_risk_gates: "Avalueu les portes d'aprovació d'adquisicions abans que els venedors s'iniciïn. Configureu els criteris de la porta (certificacions, DPA signat, qüestionari complet, risc dins del llindar), registreu les justificacions d'anul·lació i vinculeu proves.",
    vendor_risk_questionnaires: "Creeu plantilles de qüestionari de diligència deguda i assigneu-les als venedors. Feu un seguiment de la finalització de la resposta, reviseu les anotacions i les troballes que s'alimenten de la puntuació de risc i les portes d'aprovació.",
    monitoring_programs: "Crear i gestionar programes de seguiment del compliment vinculats als marcs normatius. Assignar tasques mitjançant la governança RACI i fer un seguiment de l'execució del programa.",
    monitoring_kpi: "Feu un seguiment dels KPI de compliment, les puntuacions de preparació de l'autoritat i l'estat de revisió del canvi. Visualització del tauler de control del rendiment del programa en tots els marcs actius.",
    discovery_scans: "Executeu exploracions de descoberta de dades en sistemes connectats. Gestioneu els cicles de descoberta amb la detecció delta, configureu connectors i feu un seguiment dels resultats de l'exploració.",
    discovery_classification: "Reviseu els suggeriments de descoberta, gestioneu l'àrea de prova per a les dades recentment descobertes i feu una revisió del propietari amb recomanacions de classificació.",
    discovery_management: "Configureu regles de desduplicació, gestioneu plantilles d'importació i traceu el llinatge de classificació des del descobriment fins a les etiquetes de classificació aprovades.",
    connectors_integration: "Configureu els connectors del sistema, gestioneu les credencials i controleu el bus d'esdeveniments per a la sincronització de dades en temps real entre els sistemes integrats.",
    connectors_automation: "Planifiqueu estratègies d'automatització, captureu els requisits empresarials i avalueu els quadres de comandament de prova de concepte per a projectes d'integració de sistemes.",
    connectors_governance: "Gestioneu l'inventari del sistema, feu revisions de seguretat, mantingueu matrius de traçabilitat i feu un seguiment dels registres de buits d'integració.",
    task_management_tasks: 'Consulteu i gestioneu les tasques de compliment: llista de tasques, cua de tasques personals, tasques vençudes, tauler de tasques i visualitzacions de calendari per fer un seguiment del treball a tots els mòduls.',
    task_management_workflows: "Dissenyeu i gestioneu fluxos de treball de compliment: creeu plantilles de flux de treball, configureu les assignacions de seccions i superviseu l'execució del flux de treball.",
    compliance_forms_templates: 'Exploreu i gestioneu plantilles de formularis de compliment. Accediu al catàleg de plantilles, creeu plantilles personalitzades i configureu dissenys de formularis per als enviaments reglamentaris.',
    compliance_forms_submissions: "Omplir i enviar formularis de compliment. Feu un seguiment de les instàncies del formulari, reviseu les sortides i gestioneu els paquets d'enviament per a la presentació regulatòria.",
    compliance_forms_filing: "Gestioneu els enllaços de presentació de casos, l'encaminament de seccions i la consolidació multidepartamental per a la preparació i presentació d'expedients normatius.",
    organizations_entities: "Gestioneu les entitats de l'organització, assigneu marcs reguladors per entitat i configureu les jerarquies de departament per al compliment de diverses entitats.",
    organizations_groups: 'Gestionar grups organitzatius per a empreses multientitats. Compartiu proveïdors, marcs i plantilles de formularis entre els membres del grup amb informes consolidats.',
    organizations_intake: "Configura la configuració d'admissió i gestiona l'herència de la configuració entre les jerarquies de l'organització.",
    access_accountability_sessions: "Superviseu les sessions dels usuaris, reviseu els registres d'accés i analitzeu els patrons d'accés. Feu un seguiment de l'activitat de la sessió amb l'estat d'ancoratge per a proves de responsabilitat.",
    access_accountability_reviews: "Executeu campanyes de revisió d'accés, gestioneu les revisions de justificació i feu un seguiment del progrés dels revisors. Coordinar la certificació d'accés periòdica a tota l'organització.",
    access_accountability_sod: "Definiu regles de separació de funcions, detecteu infraccions i gestioneu les excepcions. Apliqueu controls de conflicte d'interessos entre rols i permisos.",
    access_accountability_evidence: "Genereu paquets d'evidència per a revisions d'accés, realitzeu investigacions i analitzeu els patrons d'ús de rols per als informes de responsabilitat d'accés.",
    program_governance_maturity: 'Avalueu i feu un seguiment de la maduresa del programa de compliment entre marcs. Definiu models de maduresa, feu avaluacions i controleu les tendències de millora al llarg del temps.',
    program_governance_obligations: 'Mapejar les obligacions normatives a les unitats organitzatives amb govern RACI. Definir el model de govern i fer un seguiment dels plans de correcció de les llacunes identificades.',
    program_governance_documents: 'Gestionar el registre de documents de govern: redactar, revisar, emetre i fer un seguiment del reconeixement de polítiques de compliment i documents operatius.',
    program_governance_reporting: "Genereu resums executius, informes de preparació per a auditories i anàlisis de buits d'evidència. Feu un seguiment dels períodes d'informes i controleu les mètriques de salut del programa.",
    deletion_orchestration_runs: "Executar i supervisar les execucions d'orquestració d'eliminació. Feu un seguiment de les tasques d'execució, verifiqueu la integritat i gestioneu el tauler d'eliminació.",
    deletion_orchestration_vendors: "Coordinar les sol·licituds d'eliminació del proveïdor, verificar el compliment del proveïdor amb les obligacions d'eliminació i mantenir la documentació de la cadena de proves.",
    consent_management: 'Gestioneu les polítiques de consentiment, els catàlegs de finalitats i els fluxos de treball de consentiment. Configureu les regles de recollida de consentiment i feu un seguiment de les instantànies de consentiment al llarg del temps.',
    consent_cmp: 'Integració amb les plataformes de gestió del consentiment (CMP): configureu els webhooks, assigneu els propòsits de la CMP als propòsits del catàleg GRC i sincronitzeu els registres de consentiment.',
    consent_compliance: "Superviseu el compliment del consentiment: detecteu els canvis de configuració, concilieu les discrepàncies, feu el seguiment de la propagació de la retirada i reviseu la pista d'auditoria del consentiment.",
    partner_workspace_partners: "Gestioneu les organitzacions associades, realitzeu auditories de socis i gestioneu les escalades. Feu un seguiment de l'estat d'incorporació dels socis i dels requisits de compliment.",
    partner_workspace_operations: 'Gestioneu els lliuraments dels socis, les plantilles de flux de treball, els nivells de servei i els perfils de marca. Configura els fluxos de treball operatius per a la col·laboració de partners.',
    privacy_scanner_scanning: "Executeu exploracions de privadesa en temps real a llocs web i aplicacions. Reviseu els resultats de l'escaneig, feu un seguiment de l'evidència de seguiment prèvia al consentiment i gestioneu l'arxiu d'escaneig.",
    privacy_scanner_monitoring: "Configureu els taulers de control i la configuració de l'escàner de privadesa. Configureu programes d'escaneig automatitzats i gestioneu la configuració de l'escàner.",
    consent_import: 'Importació massiva de registres de consentiment des de fitxers CSV. Ideal per registrar el consentiment en paper (acords laborals, formularis de consentiment de pares/escola) a escala. Admet tipus de flux de treball de subvenció, retirada, restricció i objecció.',
    cases_import: "Importació massiva de casos de sol·licitud de drets dels subjectes de dades des de fitxers CSV. Admet fonts d'admissió multicanal, com ara enviaments per telèfon, correu postal, correu electrònic i en persona per a organitzacions que reben grans volums de DSAR.",
    data_subjects: "Consulteu els perfils unificats dels subjectes de dades que agrupen tots els casos de sol·licitud de drets i registres de consentiment per a cada individu. Feu un seguiment del cicle de vida de privadesa complet per persona: historial de consentiment, casos de DSR i cronologia d'interacció.",
    files_config: "Establiu la política de càrrega de fitxers a tota la plataforma: límits de mida, llista de tipus permesos, valors predeterminats de retenció i regles de retenció legal. Les substitucions per tipus de propietari us permeten endurir la política dels mòduls sensibles (p. ex., proves de sol·licitud de drets) mentre manteniu la resta de l'organització en un valor predeterminat. Els valors predeterminats de retenció donen suport a les expectatives de minimització de dades d'acord amb l'article 3 de la PDPL Llei 91/2025; la retenció legal suspèn la supressió durant les investigacions o disputes obertes.",
    files_browser: "Navega, cerca i gestiona tots els fitxers adjunts penjats a tota l'organització. Filtreu per mòdul de propietari, carregador, data i tipus MIME; obriu el tauler de detalls dels fitxers adjunts per veure l'historial d'auditoria, l'entitat enllaçada i l'estat de retenció. Una vista operativa, que no és específica del marc, utilitzada per administradors i auditors per trobar i classificar fitxers.",
    files_dashboard: 'Visió general operativa de la superfície del fitxer: emmagatzematge total, creixement al llarg del temps, fitxers adjunts orfes (sense entitat principal) i compliment de la política de retenció per tipus de propietari. Utilitzeu-lo per detectar la deriva de les polítiques (p. ex., un mòdul que reté fitxers més enllà de la finestra de retenció global) i per emmagatzemar pressupostos. Eines operatives: no estan vinculades a un marc normatiu específic.',
    // Module Guide records for pages that rendered no guide (idea-catalog #79).
    // English seed for structural parity (R-57); translation is tracked in
    // docs/product/phases/phase-25/sprint-58.7.0.md.
    continuity: 'Continuity plans and the exercises that test them. Record each exercise, the improvement actions it raised and whether each action has been retested — an exercise with actions still awaiting a retest is not shown as finished. The rhythm shown is the one your organisation sets.',
    deidentification: "De-identification runs over personal data. Each run records its method, a sample check and a named person's judgement of the residual re-identification risk. A run is approved only once both are recorded, and the register shows what a draft is still missing.",
    rights_requests_batch: 'Upload a CSV of rights requests and let Forseti draft a response for each row. Every draft waits for a person to accept or reject it — nothing is sent on the platform’s own initiative.',
    assessments_dossier_materialisation_health: 'The health of dossier creation for approved filings: filings still waiting for their dossier, filings whose last attempt failed and can be retried, and orphan dossiers that no filing references. Detection only — nothing is cleaned up automatically.',
    pdpl_evidence_pack_builder: 'Assemble an impact-assessment evidence pack from its part files. The pack is built the same way every time and shows its checksum and manifest, so the pack you send is the pack you reviewed.',
    pdpl_evidence_pack_detail: 'One evidence pack: its manifest, status and linked dossier, with the draft cover email, the send action and the history of every send. A pack is not edited here — rebuild it if something is wrong.',
    pdpl_evidence_pack_draft: 'Compose and edit the cover email for an evidence pack, one draft per language. Read the channel notice shown above the body before you edit it; the draft is yours to review and send.',
    pdpl_evidence_pack_email_providers: 'Configure the email provider your organisation sends evidence packs through. Packs are sent from a provider you configure — the platform is never the default sender.',
    forseti_project_detail: 'One Forseti project: its folders and documents, its members, and the conversations, reviews and drafts gathered in it so the advisor keeps its context. Rename or delete the project from its overview.',
    forseti_mcp: 'Connect Claude, Slack agents and other MCP clients to this organisation. Copy the connection details, register OAuth clients, review the apps people have connected, and issue API keys for scripts. A client secret or API key is shown once only — copy it before closing the dialog.',
    forseti_document_review: "Review a document's AI-suggested edits version by version, and accept or reject each one. Nothing Forseti suggests changes the document until a person accepts it.",
    forseti_tabular_reviews_compare: 'Compare two tabular reviews side by side over the documents they share. Matching questions are lined up, answers that differ are marked, and questions only one review asks are listed separately. Read-only.',
    forseti_tabular_reviews_detail: 'One tabular review: a grid of documents against your questions, with each answer cited to its source. The estimated cost is shown before a run starts, and cells fill in as they complete.',
    forseti_memory: 'Browse and curate what Forseti has learned about your organisation across conversations. Edit or delete an entry, or promote it to curated so the nightly retention sweep keeps it and every persona can use it.',
    credit_information_uses: "Record each use of a data subject's credit information, the purpose it served and the consent it rested on. The purposes come from your installed frameworks, and a use that needs consent is refused while none is recorded. The platform computes no score and makes no lending decision.",
    legal_matters: 'Legal matters your organisation has received — complaints, denunciations, claims and others. Each shows whether it rests on a right an installed framework declares or is tracked by choice, and a matter not yet acknowledged to whoever raised it is never shown as settled.',
    onboarding_persona_detail: 'One persona: the role it describes, its market, its suggested first task and its primary modules — marked against the modules enabled for your organisation where that can be read — with links to its use cases. The content is read from the product’s persona registry, not written for this page.',
    onboarding_use_case_detail: 'One use case from the reference set and the persona it is written for, with a link to that persona and to its onboarding path. Its steps are in its reference document, which this page names rather than restates. The content is read from the product’s use-case registry, not written for this page.',
    procedure_continuity_exercise_retest: 'Continuity Exercise and Retest',
    procedure_deidentification_run: 'De-identification Run Approval',
    procedure_ai_output_human_review: 'Human Review of AI-Assisted Output',
    procedure_evidence_pack_submission: 'Evidence Pack Assembly and Submission',
    procedure_mcp_key_lifecycle: 'Connecting MCP clients: OAuth clients, connected apps and API keys',
    procedure_framework_conflict_resolution: 'Cross-Framework Conflict Resolution',
    procedure_credit_information_use: 'Recording a Credit-Information Use',
    procedure_legal_matter_intake: 'Legal Matter Intake and Acknowledgement',
};
/**
 * fix-sprint-20260805-2128-followup — Extracted forseti.
 *
 * ca.ts exceeded the ~1MB MCP transport payload limit, blocking any
 * push of i18n updates against it. The largest top-level section
 * (forseti) lives here so the main file stays under the limit.
 * Import is spread back into ca.ts at module load — runtime shape
 * is unchanged.
 *
 * Same pattern as vi-extras.ts (added in fix-sprint-20260511-2113).
 */
export const caForseti = {
    // Sprint 63.32.0 (Q1, #543) — structural parity (R-57); English until Phase 25.
    summary_fields: {
        accepted_until: 'Accepted until',
        active_timers: 'Active timers',
        actual_release: 'Actual release',
        ad_hoc_answered: 'Ad-hoc reports answered',
        ad_hoc_report_entries: 'Ad-hoc report entries',
        affected_systems: 'Affected systems',
        amended_on: 'Last amended',
        amendments: 'Amendments',
        answered_on: 'Answered',
        approval_mode: 'Approval mode',
        approved: 'Approved',
        approved_on: 'Approved',
        approved_risk_tier: 'Approved risk tier',
        artifact_kind: 'Artefact kind',
        authorisation_kind: 'Authorisation kind',
        authority: 'Authority',
        authority_reference_recorded: 'Authority reference recorded',
        authority_request: 'Authority request',
        authority_requests: 'Authority requests',
        batches: 'Batches',
        breach_notification: 'Breach notification',
        categories: 'Category tags',
        channel: 'Channel',
        claimant: 'Claimant',
        classification: 'Classification',
        classifications: 'Classifications',
        closed_on: 'Closed',
        closure_approved_on: 'Closure approved',
        completed_on: 'Completed',
        conformity_records: 'Conformity records',
        conformity_route: 'Conformity route',
        consent_cover_state: 'Consent cover',
        consent_evidence_referenced: 'Consent evidence referenced',
        corrective_measures: 'Corrective measures',
        country: 'Country',
        covered_services: 'Covered services',
        credentials: 'Credentials',
        cross_border_transfers: 'Cross-border transfers',
        cross_mapping_recorded_on: 'Cross-mapping recorded',
        cryptographic_assets: 'Cryptographic assets',
        current_version: 'Current version',
        data_categories: 'Data categories',
        data_element: 'Data element',
        data_tier: 'Data tier',
        dataset: 'Dataset',
        deadline: 'Deadline',
        decided_on: 'Decided',
        declared_on: 'Declared',
        declared_quantity: 'Declared quantity',
        deployment_context: 'Deployment',
        deposit_submission_recorded: 'Deposit submission recorded',
        description_recorded: 'Description recorded',
        destination_country: 'Destination country',
        details_recorded: 'Details recorded',
        dictionary_version: 'Dictionary version',
        document_type: 'Document type',
        documents: 'Documents',
        domains_evaluated: 'Domains evaluated',
        dpa_status: 'DPA status',
        dpo_assigned: 'DPO assigned',
        due: 'Due',
        effective_on: 'Effective',
        evidence: 'Evidence references',
        evidence_attachments: 'Evidence attachments',
        evidence_pack_linked: 'Evidence pack linked',
        expires_on: 'Expires',
        filing_linked: 'Filing record linked',
        filing_type: 'Filing type',
        financial_crime_signed: 'Financial-crime function signed',
        fine_areas: 'Fine areas cited',
        form_type: 'Form',
        format: 'Format',
        framework: 'Framework',
        gate_kind: 'Deposit gate kind',
        generated_tasks: 'Generated tasks',
        identity_linked: 'Linked to an identity record',
        identity_verification: 'Identity verification',
        incident: 'Incident',
        incidents: 'Incidents',
        intake_evidence: 'Intake evidence',
        intake_kind: 'Intake kind',
        issued_on: 'Issued',
        jurisdiction: 'Jurisdiction',
        kind: 'Kind',
        kind_declared_by_pack: 'Kind declared by an installed pack',
        legal_basis: 'Legal basis',
        legal_review_status: 'Legal review',
        legal_reviews: 'Legal reviews',
        licence_kind: 'Licence kind',
        lifecycle_events: 'Lifecycle events',
        lifecycle_stage: 'Lifecycle stage',
        linked_activities: 'Linked activities',
        linked_authority_requests: 'Linked authority requests',
        linked_dpia: 'Linked DPIA',
        linked_frameworks: 'Linked frameworks',
        location: 'Location',
        lodged_by_role: 'Lodged by',
        lodged_on: 'Lodged',
        model_version: 'Model version',
        name: 'Name',
        notification_entries: 'Notification entries',
        notify_decision: 'Notification decision',
        offerings: 'Named offerings',
        onboarding_status: 'Onboarding',
        open_findings: 'Open findings',
        ot_asset: 'OT asset',
        outcome_reports: 'Outcome reports',
        overall_score: 'Overall score',
        parcel: 'Parcel',
        period_end: 'Period end',
        period_start: 'Period start',
        periodic_report_entries: 'Periodic report entries',
        personal_data: 'Personal data',
        phases_completed: 'Phases completed',
        phases_total: 'Phases',
        planned_release: 'Planned release',
        playbook_version: 'Playbook version',
        pre_existing_on_commencement: 'Pre-existing on commencement',
        priority: 'Priority',
        privacy_signed: 'Privacy function signed',
        procedure_reference: 'Procedure reference',
        product: 'Product',
        products: 'Products',
        proof_attachments: 'Proof attachments',
        provider: 'Provider',
        provider_type: 'Provider type',
        publication_evidence: 'Publication evidence',
        published_on: 'Published',
        purpose_recorded: 'Purpose recorded',
        purposes: 'Purposes recorded',
        questions_answered: 'Questions answered',
        questions_total: 'Questions',
        raised_on: 'Raised',
        rationale_recorded: 'Rationale recorded',
        readiness_record: 'Readiness record',
        recall_scope: 'Recall scope',
        receipt_recorded: 'Receipt recorded',
        received_on: 'Received',
        recipient: 'Recipient',
        recipient_class: 'Recipient class',
        reclassification_changed_fields: 'Inputs changed since the approved run',
        reclassification_review: 'Reclassification prompt review',
        reclassification_signal_since: 'Reclassification signal since',
        reconciliation_exceptions: 'Reconciliation exceptions',
        record_kind: 'Record kind',
        recorded_on: 'Recorded',
        reference: 'Reference',
        releasable_marked_on: 'Marked releasable',
        relied_on_events: 'Parcel events relied on',
        remediation_plans: 'Remediation plans',
        remediation_tasks: 'Remediation tasks raised',
        renewal_of_earlier: 'Renewal of an earlier credential',
        replaces: 'Replaces',
        reporting_years: 'Reporting years',
        representative_consents: 'Representative consent records',
        request_type: 'Request type',
        requester_recorded: 'Requester on record',
        responses: 'Responses',
        responsible_person_recorded: 'Responsible person recorded',
        retention_duty: 'Retention duty',
        review_due: 'Review due',
        revoked_on: 'Revoked',
        rights_evidence: 'Rights evidence entries',
        risk_level: 'Risk level',
        root_cause_recorded: 'Root cause recorded',
        rule_type: 'Rule type',
        sellers: 'Sellers',
        serial_reference: 'Serial reference',
        service_type: 'Service type',
        sharing_events: 'Sharing events',
        sharing_refusals: 'Refused sharing attempts',
        shipment: 'Shipment',
        sla_state: 'Deadline clock',
        source_country: 'Source country',
        stage: 'Stage',
        state: 'State',
        status: 'Status',
        sub_status: 'Sub-status',
        subject: 'Subject',
        subject_kind: 'Subject kind',
        submission_kind: 'Submission kind',
        submitted_on: 'Submitted',
        successor_recorded: 'Successor credential recorded',
        supplied_on: 'Supplied',
        takedown_reason_recorded: 'Takedown reason recorded',
        taken_down_on: 'Taken down',
        target_date: 'Target date',
        technical_actions: 'Technical actions',
        technical_regulation: 'Technical regulation',
        title: 'Title',
        transfer_assessment_referenced: 'Transfer assessment referenced',
        transfer_mechanism: 'Transfer mechanism',
        transfer_review_state: 'Transfer review',
        transfer_source_recorded: 'Transfer source institution recorded',
        valid_from: 'Valid from',
        valid_until: 'Valid until',
        vendor: 'Vendor',
        vendor_type: 'Vendor type',
        version: 'Version',
        versions: 'Versions recorded',
        withdrawal_determination_recorded: 'Withdrawal determination recorded',
    },
    summary_codes: {
        acknowledged: 'Acknowledged',
        active: 'Active',
        all: 'All approvers',
        any: 'Any approver',
        approved: 'Approved',
        archived: 'Archived',
        blocked: 'Blocked',
        breached: 'Breached',
        cancelled: 'Cancelled',
        closed: 'Closed',
        completed: 'Completed',
        critical: 'Critical',
        declared: 'Declared',
        do_not_notify: 'Do not notify',
        draft: 'Draft',
        escalated: 'Escalated',
        expired: 'Expired',
        filed: 'Filed',
        high: 'High',
        in_progress: 'In progress',
        in_review: 'In review',
        inactive: 'Inactive',
        known_data_subject: 'A known data subject',
        labelled_claimant: 'A labelled claimant',
        lodged: 'Lodged',
        low: 'Low',
        medium: 'Medium',
        new: 'New',
        not_started: 'Not started',
        notify: 'Notify',
        open: 'Open',
        overdue: 'Overdue',
        paused: 'Paused',
        pending: 'Pending',
        personal_data: 'Personal data',
        published: 'Published',
        received: 'Received',
        rejected: 'Rejected',
        resolved: 'Resolved',
        revoked: 'Revoked',
        signed: 'Signed',
        special_category: 'Special-category personal data',
        submitted: 'Submitted',
        suspended: 'Suspended',
        taken_down: 'Taken down',
        unclassified: 'Unclassified',
        undecided: 'Undecided',
        under_review: 'Under review',
        unverified: 'Unverified',
        verified: 'Verified',
        withdrawn: 'Withdrawn',
    },
    summary_flag_yes: 'Yes',
    summary_flag_no: 'No',
    summary_not_recorded: 'Not recorded',
    summary_fields_label: 'Record facts',
    providerSettings: {
        title: 'Forseti AI Configuració del proveïdor',
        subtitle: "Configureu el proveïdor Claude per a l'assessor legal de Forseti AI.",
        healthHeading: 'Salut del proveïdor',
        statusLabel: 'Estat',
        statusOk: "D'acord",
        statusFailed: 'No disponible',
        providerLabel: 'Proveïdor',
        providerClaudeApi: 'Claude API',
        providerCliRelay: 'Claude CLI relé',
        providerAesirManaged: 'Fitxes gestionades per Aesir',
        lastCheckedLabel: 'Darrera comprovació',
        reasonLabel: 'Raó',
        refreshButton: 'Actualitza',
        apiKeyHeading: 'Clau API de Claude',
        apiKeyHint: "La configuració d'una tecla API activa el mode API de Claude. Deixeu desactivat per utilitzar el relé CLI local (mode desenvolupador / autoallotjat).",
        apiKeyLabel: 'Tecla API.',
        apiKeyMinLength: 'Mínim 32 caràcters. Xifrat en repòs; mai més es mostra.',
        apiKeyTooShort: 'La clau API ha de tenir com a mínim 32 caràcters.',
        apiKeySaved: "S'ha desat la clau API. Salut refrescant...",
        apiKeyCleared: "S'ha esborrat la clau API. Forseti ara utilitza el relé CLI local.",
        setKeyButton: 'Desa la clau API.',
        clearKeyButton: 'Esborra la clau API (utilitza el relé CLI)',
    },
    // Owner ruling 2026-10-10 — Forseti → AI Model (provider, model, effort).
    aiModel: {
        title: 'AI Model',
        sidebarLabel: 'AI Model',
        subtitle: 'Choose the AI provider, model and effort behind every Forseti request. Your organisation connects its own provider account with its own API key, and that provider bills you directly for what Forseti uses.',
        loadError: 'The AI model settings could not be read.',
        retrySubject: 'the AI model settings',
        generalHeading: 'General',
        generalDescription: 'The active provider answers every Forseti chat, workflow, tabular review and redline. Only a provider with a saved API key can be made active.',
        activeProviderLabel: 'Active provider',
        activeProviderHint: 'A provider without a saved API key cannot be selected. Save its key in its card below first.',
        providerNoKey: '{provider} (no API key saved)',
        thinkingLabel: 'Show the reasoning summary in chat',
        thinkingHint: 'When the model returns a summary of its reasoning, Forseti shows it above the answer in interactive chat. Workflows and reviews are not affected.',
        relayProviderLabel: 'Local CLI relay (development)',
        relayUrlLabel: 'Relay address',
        relayUrlHint: 'The address of the local CLI relay. Used only in development and self-hosted installations.',
        saveGeneral: 'Save general settings',
        generalSaved: 'General settings saved.',
        providersHeading: 'Providers',
        providersDescription: 'Each provider keeps its own API key, model and effort. Saving a provider does not make it active unless you tick Make this the active provider.',
        cardDescription: "Models from {provider}, called with your organisation's own API key.",
        cardDescriptionCompatible: "Any endpoint that implements the OpenAI API, such as a model gateway or a self-hosted model server, called with that endpoint's API key.",
        activeBadge: 'Active',
        keySetBadge: 'API key saved',
        keyMissingBadge: 'No API key',
        apiKeyLabel: 'API key',
        apiKeySavedHint: 'A key ending {hint} is saved. Leave this blank to keep the saved key.',
        apiKeyNoneHint: 'No key is saved. The key is stored encrypted and is never shown again after you save it.',
        removeKey: 'Remove key',
        removeKeyTitle: 'Remove the saved API key?',
        removeKeyMessage: 'Forseti cannot call {provider} again until a new key is saved. The model and effort settings stay as they are.',
        removeKeyConfirm: 'Remove key',
        removing: 'Removing the key…',
        keyRemoved: 'The {provider} API key was removed.',
        modelLabel: 'Model',
        modelHint: 'Choose a suggested model or type any model id {provider} offers.',
        modelHintCompatible: 'Type the model id exactly as the endpoint expects it.',
        modelRequired: 'Enter a model.',
        fastModelLabel: 'Fast model (optional)',
        fastModelHint: 'Used for conversation titles and tabular extraction. Leave blank to use the main model.',
        effortLabel: 'Effort',
        effortHint: 'How much reasoning the model spends on each answer. Levels the selected model does not accept are unavailable.',
        effortUnsupported: '{effort} is not available for this model.',
        efforts: {
            default: 'Model default',
            low: 'Low',
            medium: 'Medium',
            high: 'High',
            xhigh: 'Extra high',
            max: 'Maximum',
        },
        apiModeLabel: 'API mode',
        apiModeHint: 'Automatic uses the Responses API for models that require it and Chat Completions for the rest.',
        apiModes: {
            auto: 'Automatic',
            responses: 'Responses API',
            chat_completions: 'Chat Completions API',
        },
        reasoningModeLabel: 'Reasoning mode',
        reasoningModeHint: 'Pro spends more reasoning on each answer and costs more. It is offered only for models that support it.',
        reasoningModeUnavailable: 'Pro is not available for the selected model.',
        reasoningModes: {
            standard: 'Standard',
            pro: 'Pro',
        },
        serviceTierLabel: 'Service tier',
        serviceTierHint: 'Project default uses the tier set on your provider project.',
        serviceTiers: {
            auto: 'Project default',
            default: 'Standard',
        },
        baseUrlLabel: 'Base URL',
        baseUrlHint: "The endpoint's API root over HTTPS, for example https://openrouter.ai/api/v1.",
        baseUrlRequired: "Enter the endpoint's base URL.",
        makeActiveLabel: 'Make this the active provider',
        saveButton: 'Save',
        saved: '{provider} settings saved.',
        testButton: 'Test connection',
        testing: 'Testing…',
        testNote: 'Tests the saved settings, so save your changes first. The test sends one short request containing no customer data, which your provider may charge for.',
        unsavedNote: 'This card has unsaved changes. The test uses the saved settings.',
        lastTestHeading: 'Last test',
        testNever: 'Not tested yet.',
        testPassed: 'Passed',
        testFailed: 'Failed',
        testCheckedAt: 'Checked {time}',
        testError: 'The connection test could not be run.',
        saveError: 'The settings could not be saved.',
        removeError: 'The API key could not be removed.',
        errors: {
            api_key_required: 'Save an API key for this provider before making it active.',
            api_key_required_for_new_host: 'The base URL now names another host. Enter the API key for that host before saving; the saved key is not sent to a new host.',
            invalid_api_key: 'The provider rejected this API key.',
            invalid_api_key_format: 'This does not look like a key for this provider. Check that you copied the whole key.',
            unsupported_model_effort: 'The selected model does not accept this effort level.',
            model_requires_responses: 'This model needs the Responses API. Choose Automatic or Responses API.',
            base_url_required: "Enter the endpoint's base URL.",
            invalid_base_url: 'Enter a valid HTTPS URL.',
            unsupported_provider_options: 'These options are not available for this provider.',
        },
    },
    usage: {
        title: 'Ús',
        recentHeading: 'Activitat recent',
        historyHeading: 'Últims 12 períodes',
        noActivity: 'Encara no hi ha activitat durant aquest període.',
        featureLabel: 'Característica',
        whenLabel: 'Quan',
        periodLabel: 'Període',
        byFeatureHeading: 'Aquest mes per funció',
        byFeatureEmpty: 'Encara no hi ha cap activitat destacada durant aquest període.',
        featureColumn: 'Característica',
        featureUnitsColumn: 'Unitats',
        featureRunsColumn: 'Corre',
        byUserHeading: "Aquest mes per usuari (vista d'administrador)",
        byUserEmpty: 'Encara no hi ha activitat per usuari durant aquest període.',
        userColumn: 'Usuari',
        reconciliationLinkLabel: "Veure l'informe de deriva de la conciliació",
        reconciliationLinkHint: "Només administrador intern d'Aesir.",
        // Owner ruling 2026-10-10 — consumption by provider, model and effort.
        subtitleProvider: "What Forseti has used, and the provider, model and effort each request ran on. Your organisation's AI provider bills you directly for this consumption.",
        routingHeading: 'Current routing',
        routingDescription: 'The provider, model and effort each Forseti feature uses now.',
        routingProviderLabel: 'Active provider',
        routingFeatureColumn: 'Feature',
        routingModelColumn: 'Model',
        routingEffortColumn: 'Effort',
        routingChangeLink: 'Change the AI model settings',
        routingLoadError: 'The current routing could not be read.',
        routingRetrySubject: 'the current routing',
        periodHeading: 'Consumption',
        periodDescription: 'Requests and tokens for the period you choose. The current month is shown first.',
        fromLabel: 'From',
        toLabel: 'To',
        applyPeriod: 'Show period',
        periodInvalid: 'The start date must be on or before the end date.',
        summaryLoadError: 'Consumption for this period could not be read.',
        summaryRetrySubject: 'consumption for this period',
        totalsCalls: 'Requests',
        totalsInput: 'Input tokens',
        totalsOutput: 'Output tokens',
        totalsCached: 'Cached input tokens',
        byModelHeading: 'By provider, model and effort',
        byFeaturePeriodHeading: 'By feature',
        providerColumn: 'Provider',
        modelColumn: 'Model',
        effortColumn: 'Effort',
        callsColumn: 'Requests',
        inputColumn: 'Input tokens',
        outputColumn: 'Output tokens',
        cachedColumn: 'Cached input tokens',
        tokensColumn: 'Tokens (in / out)',
        timeColumn: 'Time',
        noConsumption: 'Forseti made no requests in this period.',
        notRecorded: 'Not recorded',
        recentDescription: 'The most recent requests in the selected period.',
        recentLoadError: 'Recent activity could not be read.',
        recentRetrySubject: 'recent activity',
        byUserPeriodHeading: 'By user',
        byUserBasis: 'Counted over the {count} most recent requests in this period.',
        historyMonthlyHeading: 'Monthly consumption',
        historyConsumedColumn: 'Consumed units',
        historyLoadError: 'Monthly consumption could not be read.',
        historyRetrySubject: 'monthly consumption',
        historyEmpty: 'No earlier months recorded yet.',
        featureLabels: {
            chat: 'Xatejar',
            workflow: 'Execució del flux de treball',
            tabular: 'Extracció tabular',
            redline: 'Revisió de la línia vermella',
            title: 'Títol de la conversa',
            unknown: 'Altres',
        },
    },
    reconciliation: {
        title: 'Reconciliació de quotes de Forseti',
        subtitle: 'Drift between the fast quota counter cache and the authoritative billing ledger. The reconciler runs every 5 minutes and records any drift to the structured log channel. Aesir-internal admin only.',
        backLink: "Torna a l'ús de Forseti",
        stubHeading: 'Where reconciliation results are recorded',
        stubBody: 'This page does not show run history. Each reconciliation run writes its drift figures to the structured log channel; read them there.',
        permissionDenied: "Aquesta pàgina està restringida als administradors interns d'Aesir. Si creieu que hauríeu de tenir accés, poseu-vos en contacte amb el vostre representant de AesirX.",
    },
    projects: {
        title: 'Projectes',
        subtitle: 'Espais de treball per a documents, converses, fluxos de treball i ressenyes.',
        modeLabel: 'Veure',
        tabMine: 'Els meus projectes',
        tabShared: 'Compartit amb mi',
        searchLabel: 'Cerca projectes',
        searchPlaceholder: 'Cerca...',
        newButton: 'Nou projecte',
        colName: 'Nom',
        colVisibility: 'Visibilitat',
        colDocs: 'Documents',
        colMembers: 'Membres',
        colUpdated: 'Actualitzat',
        visibilityOwn: 'Només propi',
        visibilityShared: 'Compartit',
        emptyMine: 'Encara no hi ha projectes. Creeu-ne un per començar.',
        emptyShared: "No s'ha compartit cap projecte amb tu.",
        pageHint: 'Es mostren {shown} de {total}.',
        createTitle: 'Nou projecte',
        createSubmit: 'Crear projecte',
        fieldName: 'Nom',
        fieldDescription: 'Descripció (opcional)',
        fieldCmNumber: 'Número de cas/assumpte (opcional)',
        fieldVisibility: 'Visibilitat',
        errorNameRequired: 'El nom és obligatori.',
        errorSelectorRequired: 'Seleccioneu un usuari o grup organitzatiu per afegir.',
        renameButton: 'Canvia el nom',
        renamePrompt: 'Canvia el nom del projecte',
        deleteButton: 'Suprimeix',
        deleteConfirm: 'Delete this project? It will disappear from your projects and cannot be restored from the product.',
        deleteFolderConfirm: "Vols suprimir aquesta carpeta? Els documents a l'interior romandran al projecte, sense arxivar-se.",
        removeMemberConfirm: 'Vols suprimir aquest membre?',
        foldersHeading: 'Carpetes',
        foldersEmpty: 'Encara no hi ha carpetes.',
        addFolderButton: 'Carpeta nova',
        addFolderTitle: 'Carpeta nova',
        documentsHeading: 'Documents',
        documentsEmpty: "Encara no s'ha adjuntat cap document.",
        colFilename: 'Nom del fitxer',
        colAdded: 'Afegit',
        unattachButton: 'Desadjuntar',
        membersHeading: 'Membres',
        membersEmpty: 'Només propietari.',
        addMemberButton: 'Afegeix un membre',
        addMemberTitle: 'Afegeix un membre',
        addMemberSubmit: 'Afegeix un membre',
        colMember: 'Membre',
        colRole: 'Rol',
        selectorTypeLabel: 'Afegeix per',
        selectorUser: "ID d'usuari",
        selectorGroup: 'Identificador del grup organitzatiu',
        fieldUserId: 'Usuari',
        fieldGroupId: 'Grup organitzatiu',
        fieldRole: 'Rol',
        roleAdmin: 'Admin',
        roleEditor: 'Editor',
        roleViewer: 'Visor',
        notFound: 'Projecte no trobat.',
        selectUserPlaceholder: 'Seleccioneu un usuari...',
        selectGroupPlaceholder: 'Seleccioneu un grup organitzatiu...',
        noUsersAvailable: 'No hi ha usuari disponible.',
        noGroupsAvailable: 'No hi ha cap grup organitzatiu disponible.',
        loadFailed: "No s'han pogut carregar les opcions.",
        deleteProjectTitle: 'Vols suprimir el projecte?',
        deleteFolderTitle: 'Vols suprimir la carpeta?',
        removeMemberTitle: 'Vols suprimir el membre?',
        removeMemberConfirmGeneric: 'Vols suprimir aquest membre del projecte?',
        addDocumentButton: 'Afegir document',
        addDocumentTitle: 'Afegir document al projecte',
        fieldDocument: 'Seleccionar document',
        selectDocPlaceholder: 'Cerca un document...',
        ownerLabel: 'Propietari del sistema',
    },
    chat: {
        sidebarLabel: 'Xats',
        overviewTitle: 'Forseti',
        overviewSubtitle: "El vostre AI Assessor legal i de compliment, basat en les dades de l'arrendatari i els paquets reguladors instal·lats.",
        personaSelectorLabel: 'Persona',
        personaHeading: 'Tria una persona',
        startChatButton: 'Inicia un xat nou',
        startingChat: "S'està iniciant el xat...",
        recentHeading: 'Xats recents',
        recentEmpty: 'Encara no hi ha cap xat; inicieu-ne un a dalt.',
        untitledChat: 'Xat nou',
        chatLoadFailed: 'Forseti could not load this chat.',
        streamFailed: 'Forseti could not finish this reply. Your message is still in the box.',
        personaSwitchFailed: 'The persona could not be changed.',
        renameFailed: 'The chat could not be renamed.',
        deleteFailed: 'The chat could not be deleted.',
        messageListLabel: 'Conversa',
        detailSubtitle: 'Persona: {persona}',
        composeHeading: 'Envia un missatge',
        composeLabel: 'Missatge Forseti',
        composeDisabledPlaceholder: 'This chat is read-only.',
        composeDisabledHint: 'You can read this conversation but not add to it.',
        switchPersonaHeading: 'Persona',
        presetPersona: 'Persona predefinida',
        changePersona: 'Canvia de persona',
        hidePersonaOptions: 'Amaga les opcions de persona',
        starterHeading: 'Comença amb una d’aquestes accions',
        renameButton: 'Canvia el nom',
        renamePrompt: 'Canvia el nom del xat',
        deleteButton: 'Suprimeix',
        deleteConfirm: 'Delete this chat? It will disappear from your chats and cannot be restored from the product.',
        notFound: "No s'ha trobat el xat.",
        emptyChat: 'Encara no hi ha missatges: saludeu-vos per iniciar una conversa.',
        roleUser: 'tu',
        roleAssistant: 'Forseti',
        roleSystem: 'Sistema',
        thinkingLabel: 'Pensant',
        toolCallPlaceholder: "Trucada de l'eina:",
        toolResultPlaceholder: 'Tool result hidden.',
        docEditPlaceholder: 'Es proposen edicions de documents (V{version}).',
        disclaimer: "Forseti dóna suport al vostre judici; no substitueix l'advocat amb llicència.",
        sendButton: 'Enviar',
        sending: "S'està enviant…",
        composePlaceholder: 'Pregunta a Forseti...',
        composingPlaceholder: 'Forseti està responent...',
        streamingPlaceholder: 'Forseti està escrivint...',
        promptInjectionTitle: 'Forseti va deixar caure algunes fitxes de control.',
        promptInjectionBody: 'Patrons despullats: {patterns}. Forseti només veurà el text del teu missatge.',
        rateLimitTitle: 'Estàs enviant missatges massa ràpid.',
        rateLimitRetryAfter: "Torna-ho a provar d'aquí a {seconds}s.",
        messageLength: '{count} / {max} characters',
        messageTooLong: 'Messages to Forseti are limited to {max} characters. Shorten the message or split it in two.',
        counselReviewTitle: 'Forseti és incert aquí.',
        counselReviewBody: "Confirmeu amb un advocat autoritzat abans d'actuar amb aquesta resposta.",
        legalConclusionRefused: 'Forseti es va negar a emetre una conclusió legal sense fonament. Proveu search_regulatory primer o acudiu a un assessor.',
        toolCallDone: 'Fet.',
        toolCallArgsLabel: 'Arguments',
        toolCallResultLabel: 'Resultat',
        toolResultLogged: "Resultat de l'eina capturat al registre d'auditoria.",
        toolResultAria: "resultat de l'eina",
        documentEditAria: 'edició del document',
        createTaskFromMessage: "Crea una tasca a partir d'això",
        createTaskHeading: "Crea una tasca a partir d'aquest missatge",
        createTaskTitleLabel: 'Títol',
        createTaskTitleRequired: 'El títol és obligatori.',
        createTaskDescriptionLabel: 'Descripció',
        createTaskAssigneeLabel: 'Cesionari',
        createTaskAssigneePlaceholder: "Seleccioneu l'assignat...",
        createTaskAssigneeNone: '- no assignat -',
        createTaskDueDateLabel: 'Data de venciment',
        createTaskWorkflowLabel: 'Flux de treball enllaçat (opcional)',
        createTaskWorkflowPlaceholder: 'Seleccioneu un flux de treball...',
        createTaskWorkflowNone: '- cap -',
        renameModalSubmit: 'Canvia el nom',
        renameModalSaving: "S'està desant…",
        deleteConfirmTitle: 'Vols suprimir el xat?',
        createTaskSubmit: 'Crea una tasca',
        createTaskSubmitting: "S'està creant…",
        cancelButton: 'Cancel·la',
        autoRouteHintMessage: 'Aquesta pregunta es troba més a la timonera de {persona}.',
        autoRouteSwitchButton: 'Canvia a {persona}',
        autoRouteSwitching: "S'està canviant...",
        handoffSuggestionMessage: 'O obre un xat nou amb {persona} fent endavant aquesta pregunta.',
        handoffSuggestionButton: 'Inicia un xat nou amb {persona}',
        handoffSuggestionWorking: 'Obertura…',
        handoffSuggestionDismiss: 'Ara no',
        handoffSuggestionFailed: 'The new chat could not be opened.',
        persona_display: {
            'forseti-generalist': 'Forseti',
            'forseti-compliance': 'Especialista en compliment',
            'forseti-legal': 'Assessor jurídic',
            'forseti-dpo': 'Assessor DPO',
            'forseti-risk': 'Analista de risc',
            'forseti-auditor': "Mirada de l'auditor",
        },
        exportButton: 'Exportar PDF',
        exportRunning: 'Exportant…',
        exportSuccess: 'Exportat: {filename} (obriu el navegador de fitxers).',
        exportOpenFile: 'Obre al navegador de fitxers',
        exportDownload: 'Baixa el PDF',
        citation: {
            verifyBadge: '[VERIFICAR]',
            verifyAria: "la citació no s'ha pogut verificar: revisa abans de confiar-te",
            popoverAria: 'Font de {label}',
            openSource: 'Pàgina de codi obert',
        },
    },
    auditTrail: {
        forsetiBadge: 'Forseti',
        forsetiBadgeTooltip: "Esdeveniment generat per AI des de la pista d'auditoria de Forseti.",
    },
    rowAction: {
        ask: 'Pregunta a Forseti',
        tooltipOpen: 'Pregunteu a Forseti sobre aquest {recordType}',
        tooltipLocked: 'Aquest {recordType} està bloquejat — Forseti pot respondre preguntes però no pot fer canvis.',
    },
    // ── Sprint 63.22.0 — the global Forseti launcher and its launchpad ──
    launcher: {
        openLabel: 'Open Forseti',
        tooltip: 'Ask Forseti (Ctrl+Shift+F)',
        modalTitle: 'Forseti',
        personaHeading: 'Choose who to ask',
        scopeHeading: 'What the chat is about',
        askAboutRecord: 'Ask about this {record}',
        generalChat: 'General chat',
        attachRecord: 'Attach a record',
        attachRecordRequired: 'Choose a record to attach, or choose General chat.',
        recordScopeLost: 'This page no longer shows a record, so this will be a general chat.',
        recentChats: 'Recent chats',
        recentEmpty: 'You have no chats yet.',
        resumeChat: 'Resume {title} — {persona}, {date}',
        startChat: 'Start chat',
        starting: 'Starting chat…',
        openFullView: 'Open in full view',
        loadFailed: 'Forseti could not load your personas and recent chats.',
        noPersonas: 'No Forseti persona is enabled for your organisation.',
    },
    advisorRunPanel: {
        // fix-sprint-20260627-2217-followup F11 — the chat's back control names
        // where it goes (WCAG 2.4.6); it returns to the launchpad.
        backToOptions: 'Back to Forseti options',
        title: 'Forseti — sobre aquest disc',
        heading: 'Forseti — {recordType}',
        summaryLabel: 'Resum',
        suggestedPersona: 'Persona suggerida',
        askForseti: 'Pregunta a Forseti',
        runWorkflow: 'Executeu un flux de treball',
        viewLineage: "Veure el llinatge d'auditoria",
        createPdplEvidencePack: 'Crea el paquet de proves PDPL',
        prepareBreachDraft: "Prepara l'esborrany de notificació",
        primaryActions: {
            projectSummary: 'Resumir el document del projecte',
            supplementSummary: 'Resumir la sol·licitud suplementària',
            authoritySummary: "Resumir la sol·licitud de l'autoritat",
            rightsRequestResponse: 'Redactar resposta DSR',
            dpiaQuickReview: 'Executar revisió ràpida DPIA',
            taskControlWalkthrough: 'Recórrer evidència de control',
            vendorRiskNarrative: 'Generar narrativa de risc del proveïdor',
            incidentLetter: 'Redactar carta de bretxa PDPL',
            ropaSufficiency: 'Executar comprovació de suficiència RoPA',
            vendorDpaReview: 'Executar revisió DPA del proveïdor',
        },
        builtinWorkflowViews: {
            ropaSufficiency: {
                title: 'RoPA Sufficiency Check',
                notice: 'Runs the existing RoPA sufficiency workflow for this processing activity. The run may create draft follow-up tasks; operators still review and execute them.',
            },
            vendorDpaReview: {
                title: 'Vendor DPA Review',
                notice: 'Runs the existing Vendor DPA Review workflow for this vendor contract. The run may create draft follow-up tasks; operators still review every finding and task.',
            },
            vendorRiskNarrative: {
                title: 'Vendor Risk Narrative',
                notice: 'Runs the existing vendor risk narrative workflow for this vendor. Output remains draft evidence; the human risk owner reviews and approves it before use.',
            },
            incidentLetter: {
                title: 'PDPL Breach Notification Letter',
                notice: 'Runs the existing VN PDPL breach-notification letter workflow for this incident or playbook activation. Output remains draft only; formal regulator filing still requires human sign-off.',
            },
            projectSummary: {
                title: 'Project Document Summary',
                notice: 'Runs the existing uploaded-document summary workflow for this Forseti project. The workflow is read-only and does not create tasks, evidence, or record updates.',
            },
            supplementSummary: {
                title: 'Supplement Request Summary',
                notice: 'Runs the existing uploaded-document summary workflow for this supplement request. The workflow is read-only and does not create tasks, evidence, record updates, or filing decisions.',
            },
            authoritySummary: {
                title: 'Authority Request Summary',
                notice: 'Runs the existing uploaded-document summary workflow for this authority request. The workflow is read-only and does not create tasks, evidence, record updates, filing decisions, or authority-response drafts.',
            },
            rightsRequestResponse: {
                title: 'DSR Response Draft',
                notice: 'Runs the existing DSR response draft workflow for this rights request. Output remains draft only; sending and case updates still require the existing human-reviewed rights-request flow.',
            },
            dpiaQuickReview: {
                title: 'DPIA Quick Review',
                notice: 'Runs the existing DPIA Quick Review workflow for this DPIA. The run may create draft follow-up tasks; operators still review every finding and task.',
            },
            taskControlWalkthrough: {
                title: 'Control Evidence Walkthrough',
                notice: 'Runs the existing compliance-control walkthrough for this task. The workflow must retrieve regulatory anchors before citing them, does not issue legal conclusions or mark controls/evidence approved, and only creates draft evidence placeholders when the operator explicitly requests them.',
            },
        },
        breachDraftNotice: 'Forseti només prepara contingut provisional per al Mẫu số 08 enllaçat. No decideix si cal notificar ni presenta o envia el formulari.',
        breachDraftReady: 'Esborrany del Mẫu số 08 preparat per revisar',
        breachDraftReviewBeforeSelecting: 'Revisa abans de seleccionar',
        workflowHeading: 'Fluxos de treball rellevants',
        workflowLoading: 'S’estan carregant els fluxos de treball rellevants…',
        workflowEmpty: 'No s’ha trobat cap flux de treball adequat. Creeu un flux de treball guiat per a aquest registre.',
        workflowError: 'No s’han pogut carregar els fluxos de treball rellevants.',
        selectWorkflow: 'Selecciona {title}',
        workflowSelected: 'Flux de treball seleccionat i preparat per executar-se amb aquest registre.',
        workflowRunSelected: 'Executa el flux de treball seleccionat',
        workflowStarting: 'S’està iniciant el flux de treball…',
        workflowRunError: 'No s’ha pogut iniciar aquest flux de treball.',
        workflowCreateGuided: 'Crea un flux de treball guiat per a aquest registre',
        lineageHeading: 'Traçabilitat d’auditoria d’aquest registre',
        lineageLoading: 'S’està carregant la traçabilitat d’auditoria…',
        lineageEmpty: 'No hi ha esdeveniments de traçabilitat de Forseti registrats per a aquest registre.',
        lineageError: 'No s’ha pogut carregar la traçabilitat d’auditoria.',
        retry: 'Torna-ho a provar',
        chatContextLoading: 'S’està carregant el context del registre…',
        chatGuidance: {
            general: 'Forseti pot resumir aquest registre, identificar la informació que falta i suggerir passos de revisió.',
            privacy: 'Forseti pot revisar els fets de privadesa, comprovar les obligacions dels marcs instal·lats i ajudar a preparar un esborrany per a revisió humana.',
            compliance: 'Forseti pot identificar mancances de compliment, fonamentar els requisits en les fonts instal·lades i suggerir els passos següents amb responsables clars.',
            legal: 'Forseti pot resumir el registre, localitzar material de referència fonamentat i ajudar a preparar un esborrany perquè el revisi l’assessoria jurídica.',
            risk: 'Forseti pot avaluar els riscos registrats, assenyalar els fets que falten i suggerir passos de revisió proporcionats.',
            audit: 'Forseti pot examinar mancances de proves, relacionar el registre amb els controls instal·lats i suggerir un seguiment preparat per a auditoria.',
        },
        starterPrompts: {
            identifyGaps: 'Quina informació o quines proves falten en aquest registre?',
            reviewFrameworks: 'Quines obligacions dels nostres marcs instal·lats he de revisar per a aquest registre?',
            prepareDraft: 'Ajuda’m a preparar un esborrany basat només en aquest registre i en fonts instal·lades fonamentades.',
            nextSteps: 'Quins passos de revisió he de seguir ara?',
            summarizeRecord: 'Resumeix aquest registre i assenyala els punts que necessiten revisió humana.',
            assessRisk: 'Avalua els riscos registrats, identifica els fets que falten i suggereix passos de revisió.',
        },
        disclaimer: "Forseti dóna suport al vostre judici; no substitueix l'advocat amb llicència.",
        recordType: {
            project: 'Projecte',
            dpia: 'DPIA',
            dossier_filing: 'Presentació del dossier',
            transfer_assessment: 'Transferència transfronterera',
            vendor: 'Venedor',
            vendor_contract: 'Contracte de venedor',
            vendor_acceptance: 'Acceptació del risc del venedor',
            incident: 'Incident',
            incident_op: "Operació d'incidències",
            breach_notification: "Notificació d'incompliment",
            authority_request: "Sol·licitud de l'autoritat",
            supplement_request: 'Sol·licitud de suplement',
            rights_request: 'Sol·licitud de drets',
            contract: 'Contracte',
            task: 'Tasca',
            data_mapping_activity: 'Activitat RoPA',
            compliance_rule: 'Norma de compliment',
            program: 'Programa',
            governance_document: 'Document de govern',
            remediation_plan: 'Pla de reparació',
            cross_border_filing: 'Arxiu transfronterer',
            enforcement_case: 'Enforcement Case',
            authority_direction: 'Authority Direction',
            regulated_account: 'Regulated Account',
            regulatory_placeholder: 'Regulatory Placeholder',
            sector_licence: 'Sector Licence',
            credit_information_supply: 'Credit-Information Supply',
            data_service_provider: 'Data-Service Provider Record',
            regulatory_disclosure: 'Regulatory Disclosure',
            issued_record: 'Student Record',
            publication: 'Publication',
        },
    },
    autocomplete: {
        // fix-sprint-20260627-2217-followup F9, verifier round 1 — the 409 refusal
        // when no installed framework grounds the draft (raw English before).
        error_no_grounding_scope: 'Forseti cannot draft this DPIA: no framework for this frame is installed with a usable status, so there is no regulatory text to ground the draft on. Nothing was drafted.',
        button_label: 'Demaneu a Forseti que escrigui això',
        drafting: 'Redacció…',
        hint_pick_activity: 'Trieu una activitat de processament enllaçada per habilitar la redacció de Forseti.',
        draft_origin_label: 'Esborrany de Forseti: revisió per camp',
        tokens_label: '≈ {count} fitxes del teu cub mensual',
        accept_selected: 'Accepta seleccionat',
        reject_all: "Rebutja l'esborrany",
        field_checkbox_label: "Aplica l'esborrany de Forseti per a {field}",
        field_labels: {
            description: 'Descripció',
            purpose: 'Propòsit',
            data_subjects: 'Supòsits de dades',
            data_types: 'Tipus de dades',
            necessity_justification: 'Necessitat i proporcionalitat',
            consultation_notes: 'Notes de consulta',
            dpo_opinion: 'DPO opinió',
            system_ids: 'Sistemes enllaçats',
            vendor_ids: 'Proveïdors vinculats',
        },
        error_generic: "Forseti no ha pogut redactar aquest DPIA. Torna-ho a provar o millora el registre d'activitat.",
        variant_legend: 'Marc marc',
        variant_label_gdpr: 'GDPR',
        variant_none_available: 'No hi ha cap marc instal·lat disponible',
        variant_label_pdpl: 'PDPL',
        variant_label_nis2: 'NIS2',
        variant_label_iso27001: 'ISO 27001',
        variant_label_soc2: 'SOC 2',
        conflict_banner: "Avís: {count} s'apliquen conflictes entre marcs a aquesta variant. Revisa abans d'acceptar.",
    },
    formDraft: {
        button_label: 'Demana a Forseti que redacti aquest formulari',
        drafting: 'S’està redactant…',
        draft_origin_label: 'Esborrany de Forseti — reviseu cada camp',
        tokens_label: '≈ {count} tokens de la vostra quota mensual',
        accept_selected: 'Accepta els seleccionats',
        reject_all: 'Rebutja l’esborrany',
        field_checkbox_label: 'Aplica l’esborrany de Forseti per a {field}',
        excluded_note: 'No es poden redactar {count} camp(s) (referències, adjunts o només de lectura).',
        error_generic: 'Forseti no ha pogut redactar aquest formulari. Torneu-ho a provar.',
        empty_draft: 'Forseti no ha generat cap esborrany de camp per a aquest formulari.',
    },
    tia: {
        // fix-sprint-20260627-2217-followup F9, verifier round 1 — the 409 refusal
        // when no installed framework grounds the draft (raw English before).
        error_no_grounding_scope: 'Forseti cannot draft this TIA: no framework that governs this transfer is installed with a usable status, so there is no regulatory text to ground the draft on. Nothing was drafted.',
        button_label: 'Demaneu a Forseti que redacti aquest TIA',
        drafting: 'Redacció TIA...',
        hint_pick_destination: 'Establiu el país de destinació al registre de transferència abans que Forseti pugui redactar.',
        draft_origin_label: 'Esborrany de Forseti TIA: revisió per camp',
        tokens_label: '≈ {count} fitxes del teu cub mensual',
        accept_selected: 'Accepta seleccionat',
        reject_all: "Rebutja l'esborrany",
        field_checkbox_label: "Aplica l'esborrany de Forseti per a {field}",
        error_generic: 'Forseti no va poder redactar aquest TIA. Torna-ho a provar o millora el registre de transferència.',
        usage_details: "Detalls d'ús de la IA",
        applied_status: 'Draft accepted. The selected fields are saved to the transfer record.',
        recommended_updates_title: 'Actualitzacions de registre recomanades',
        mechanism_recommendation: 'Mecanisme de transferència: {value}',
        dpo_review_recommendation: 'Ask your DPO to review this sensitive transfer.',
        review_date_warning: "Establiu un termini de revisió abans d'actualitzar aquesta transferència sensible.",
        processing_activity_warning: 'Vinculeu almenys una activitat de tractament / registre ROPA abans de completar la TIA.',
        go_to_field: 'Vés al camp',
        adequacy_label: 'Règim de destinació',
        adequacy_label_source_route: 'Transfer route',
        adequacy_status_adequacy_decision: 'EU adequacy decision (exports from the EU/EEA)',
        adequacy_status_non_adequacy_with_sccs: 'No EU adequacy decision — GDPR Art. 46 safeguard for exports from the EU/EEA',
        adequacy_status_derogation: 'GDPR Art. 49 derogation (exports from the EU/EEA)',
        adequacy_needs_action: 'Action needed',
        adequacy_for_information: 'For information',
        adequacy_status_transitional: 'Drecera de transició/EEE',
        adequacy_status_unknown: 'Desconegut: defineix la destinació',
        adequacy_status_source_jurisdiction_route: 'Transfer out of Vietnam — impact-assessment dossier route',
        adequacy_summary_no_destination: 'No destination country is set. Select the destination before Forseti drafts a TIA.',
        adequacy_summary_intra_eea: 'Transfer within the EEA ({code}) — for an export from the EU/EEA, no third-country TIA is required under GDPR Arts. 44–50. A transfer out of Vietnam is assessed under Law 91/2025/QH15 Art. 20 and Decree 356/2025/NĐ-CP Arts. 17–18 unless an evidenced exception applies.',
        adequacy_summary_inbound: 'Vietnam destination — an exporter in the EU/UK establishes its own transfer mechanism; the Vietnam-origin transfer impact-assessment rules do not apply to an inbound route. GDPR applies only where the record establishes an EU/EEA jurisdiction trigger.',
        adequacy_summary_us_dpf: 'US recipient certified under the Data Privacy Framework — for an export from the EU/EEA, covered by the European Commission adequacy decision of 10 July 2023 while the recipient stays on the active DPF list. Confirm the certification at https://www.dataprivacyframework.gov before relying on it.',
        adequacy_summary_us_no_dpf: 'US destination not under the DPF — for an export from the EU/EEA, no EU adequacy decision covers a non-certified recipient, and the Schrems II surveillance-law concerns (FISA §702, EO 12333) call for supplementary measures.',
        adequacy_summary_eu_adequacy: '{code} has an active European Commission adequacy decision — an export from the EU/EEA may proceed without SCCs or supplementary measures, subject to the Commission’s ongoing monitoring.',
        adequacy_summary_eu_no_adequacy: '{code} has no active EU adequacy decision. An export from the EU/EEA may rely on GDPR Art. 46 safeguards (standard contractual clauses, BCRs, certification or a code of conduct) with a Schrems II assessment of the destination, or on a GDPR Art. 49 derogation.',
        adequacy_summary_source_jurisdiction_route: 'Transfer out of Vietnam to {code} — assessed on the route Law 91/2025/QH15 Art. 20 states: the transfer impact-assessment dossier (Decree 356/2025/NĐ-CP Arts. 17–18), unless an exception those instruments state is evidenced. The EU adequacy classification is not used to frame this route; where the record establishes that the GDPR reaches the exporter for this processing (Art. 3), its Chapter V applies in addition.',
        adequacy_summary_source_jurisdiction_route_exemption: 'Transfer out of Vietnam to {code} — assessed on the route Law 91/2025/QH15 Art. 20 states: the transfer impact-assessment dossier (Decree 356/2025/NĐ-CP Arts. 17–18), unless an exception those instruments state is evidenced. A possible exception is flagged from the record; it is not a confirmed exception and needs affirmative evidence and Compliance/Legal review. The EU adequacy classification is not used to frame this route; where the record establishes that the GDPR reaches the exporter for this processing (Art. 3), its Chapter V applies in addition.',
        conflict_banner: "Avís: {count} s'apliquen conflictes entre marcs a aquest règim de transferència. Revisa abans d'acceptar.",
        field_label_description: 'Description',
        field_label_purpose: 'Purpose',
        field_label_transfer_mechanism_detail: 'Transfer mechanism detail',
        field_label_recipient_name: 'Recipient name',
        field_label_recipient_details: 'Recipient details',
        field_label_data_subjects: 'Data subjects',
        field_label_data_types: 'Data types',
    },
    // Sprint 48.3.6 — shared draft output-guardrail labels (TIA + DPIA + all draft workflows).
    guardrails: {
        missing_facts_title: 'Dades obligatòries que falten',
        missing_facts_hint: 'Forseti ha detectat dades que no consten al registre. Els camps que en depenen no es preseleccionen: aporteu les dades o accepteu el camp de manera deliberada.',
        risk_label: 'Risc calibrat',
        risk_low: 'Baix',
        risk_medium: 'Mitjà',
        risk_high: 'Alt',
        jurisdiction_label: 'Desencadenants de jurisdicció',
        jurisdiction_none_installed: "Cap marc instal·lat no cobreix aquesta avaluació: no s'ha avaluat cap règim jurídic. Instal·leu un paquet normatiu adequat abans de basar-vos en les conclusions jurídiques d'aquest esborrany.",
        jurisdiction_none_assessed: "Forseti no ha retornat cap avaluació de jurisdicció. No s'ha avaluat res: això no és una conclusió que no s'apliqui cap règim.",
        jurisdiction_inactive: 'The framework covering this assessment is installed but no longer in force — so no legal regime was assessed. There is nothing to install: activate the current instrument, or the one that replaces it, before relying on the legal conclusions here.',
        jurisdiction_resolving: 'S’estan carregant els noms dels règims avaluats…',
        trigger_applicable: 'S’aplica',
        trigger_not_applicable: 'No activat',
        trigger_unknown: 'Desconegut — falta la dada',
        recipient_role_label: 'Rol del destinatari',
        recipient_role_controller: 'Responsable del tractament',
        recipient_role_processor: 'Encarregat del tractament',
        recipient_role_joint_controller: 'Corresponsable',
        recipient_role_unknown: 'Desconegut — no indicat',
        opt_in_hint: 'Conclusió jurídica: activeu-la només si l’accepteu amb les dades disponibles.',
    },
    mcp: {
        pageTitle: 'Claus del connector MCP',
        pageSubtitle: 'Connect Claude, Slack agents and other MCP clients to Forseti. A connected client reads your organisation’s records within the access you grant, and anything it proposes to change waits in the approval queue until an administrator approves it.',
        issueButton: 'Emet una nova clau',
        issueModalTitle: 'Emet la clau API MCP',
        labelField: 'Etiqueta',
        labelHint: 'Una breu descripció (p. ex., "AI laboratori de capacitats — investigació regulatòria").',
        permittedToolsField: 'Eines permeses',
        expiresAtField: 'Caduca (opcional)',
        expiresAtHint: 'Deixa en blanc perquè no caduqui mai.',
        submit: "Clau d'emissió",
        cancel: 'Cancel·la',
        keyDisplayedOnce: 'Copieu aquesta clau ara; NO la podreu tornar a veure. Emmagatzemeu-lo al vostre gestor secret (1 Password, AWS Secrets Manager, Vault, etc.).',
        keyDisplayedOnceClose: 'El vaig copiar: tancar',
        colLabel: 'Etiqueta',
        colPrefix: 'Prefix',
        colStatus: 'Estat',
        colTools: 'Eines',
        colCreatedAt: 'Creat',
        colLastUsed: 'Últim ús',
        colCalls: 'Trucades',
        colActions: 'Accions',
        statusActive: 'Actius',
        statusRevoked: 'Revocat',
        statusExpired: 'Caducat',
        revokeAction: 'Revocar',
        rotateAction: 'Gira',
        confirmRevokeTitle: 'Vols revocar aquesta clau MCP?',
        confirmRevokeBody: "Els clients externs de Claude que utilitzen aquesta clau perdran l'accés immediatament. Això no es pot desfer.",
        confirmRevoke: 'Revoca clau',
        rotatedTitle: 'Tecla girada',
        rotatedBody: "La nova clau de text sense format es troba a continuació. La clau antiga continua funcionant durant 5 minuts, de manera que s'acaben les trucades durant el vol.",
        emptyState: "Encara no s'ha emès cap clau MCP.",
        errorIssue: "No s'ha pogut emetre la clau MCP.",
        errorList: "No s'han pogut carregar les claus MCP.",
        errorRevoke: "No s'ha pogut revocar la clau.",
        errorRotate: "No s'ha pogut girar la clau.",
        neverUsed: '—',
        neverExpires: 'Mai',
        // Sprint 63.23.0 — the connector page leads with how to connect.
        reloadKeys: 'Reload API keys',
        issuing: 'Issuing…',
        labelRequired: 'Enter a label for the key.',
        toolsRequired: 'Choose at least one tool.',
        webhookField: 'Status callback URL (optional)',
        webhookHint: 'ComplianceOne posts the outcome of each queued write to this address, signed with a secret that is shown once.',
        webhookInvalid: 'Enter a full address, for example https://example.com/hooks/mcp.',
        webhookSecretLabel: 'Webhook signing secret',
        webhookSecretOnce: 'Copy the signing secret now. It is shown once.',
        toolGroupRead: 'Read tools',
        toolGroupWrite: 'Write tools',
        toolGroupWriteHint: 'A write tool never changes a record directly. Each call goes to the approval queue and runs only after an administrator approves it.',
        toolGroupMemory: 'Organisation memory',
        toolGroupSubagent: 'Persona handoff',
        toolQueued: 'goes to the approval queue',
        allToolsInScope: 'Every tool its scopes allow',
        copy: 'Copy',
        copyValue: 'Copy {label}',
        copiedValue: '{label} copied',
        copyFailed: 'Could not copy {label}. Select the value and copy it yourself.',
        apiKeyLabel: 'API key',
        registers: {
            clients: 'OAuth clients',
            grants: 'Connected apps',
            keys: 'API keys',
        },
        connection: {
            title: 'Connection details',
            intro: 'Every client needs the server URL. OAuth clients also use the addresses below; clients that use an API key send it as a bearer token.',
            serverUrl: 'Server URL',
            transport: 'Transport',
            transportStreamableHttp: 'Streamable HTTP',
            protectedResourceMetadataUrl: 'Protected resource metadata URL',
            asMetadataUrl: 'Authorization server metadata URL',
            authorizeUrl: 'Authorize URL',
            tokenUrl: 'Token URL',
            registrationUrl: 'Client registration URL',
            revokeUrl: 'Revocation URL',
            scopes: 'Scopes',
            loading: 'Loading connection details…',
            error: 'The connection details could not be read, so no server URL is shown.',
            reload: 'Reload connection details',
        },
        dcr: {
            label: 'Let clients register themselves',
            hint: 'When this is on, a client such as Claude can register itself and ask a signed-in user to approve it. It has no access until a user of this organisation approves it on the consent screen. Switching it off disconnects apps that registered themselves at their next call; clients registered below and API keys keep working. Switching it back on lets those apps work again.',
            stateOn: 'On — clients can register themselves.',
            stateOff: 'Off — only clients registered below can connect.',
            saving: 'Saving…',
            error: 'Could not change whether clients can register themselves.',
            confirmOffTitle: 'Switch off self-registration?',
            confirmOffBody: 'Apps that registered themselves, such as Claude, are disconnected at their next call for everyone in this organisation, and nobody can approve a new one. Clients registered below and API keys keep working. The connections are suspended, not revoked: switching self-registration back on lets them work again.',
            confirmOff: 'Switch off',
        },
        tabs: {
            label: 'How to connect',
            claude: 'Claude',
            slack: 'Slack and other agent builders',
            apiKey: 'API key',
        },
        claudeTab: {
            step1: 'In Claude, add a custom connector.',
            step2: 'Paste the server URL. Claude finds out how to sign in by itself.',
            step3: 'Sign in to ComplianceOne when asked, then read the consent screen and approve it.',
            consentHeading: 'What the consent screen shows',
            consentItemClient: 'the app’s name and the address it will send you back to;',
            consentItemOrg: 'your organisation;',
            consentItemScopes: 'what it may do — read your organisation’s records, and propose changes for approval if that is requested — and the tools that reach;',
            consentItemOrigin: 'whether the app registered itself or an administrator registered it.',
            actsAsUser: 'Claude then acts as the person who approved it, with no more access than that person’s own role gives them.',
            registrationOff: 'Clients cannot register themselves in this organisation, so Claude cannot connect with the server URL alone. Switch self-registration on, or register a client for Claude under OAuth clients.',
        },
        slackTab: {
            intro: 'Agent builders such as Slack ask for OAuth fields. Register a client under OAuth clients, then copy each value into the builder’s form.',
            colField: 'Field in the agent builder',
            colValue: 'Value',
            fieldServerUrl: 'MCP server URL',
            fieldClientId: 'Client ID',
            fieldClientSecret: 'Client secret',
            fieldAuthorizeUrl: 'Authorize URL',
            fieldTokenUrl: 'Token URL',
            fieldScopes: 'Scopes',
            valueClientId: 'Shown on the client’s row under OAuth clients.',
            valueScopes: 'Enter only the scopes shown on your client’s row under OAuth clients. A scope the client was not registered with is refused.',
            valueClientSecret: 'Shown once, when you register the client or rotate its secret. Store it in the agent builder straight away.',
            redirectNote: 'The agent builder shows the redirect URI it uses. Add it to the client exactly as shown: ComplianceOne sends people back only to a redirect URI registered on the client.',
            registerCta: 'Register a client',
        },
        apiKeyTab: {
            intro: 'Scripts and custom clients can use an API key instead of OAuth. Issue a key under API keys and send it on every request.',
            headerLabel: 'Header',
            configLabel: 'Client configuration (JSON)',
            curlLabel: 'Check the connection with curl',
            actsAsIssuer: 'A call made with a key acts as the administrator who issued it, limited to the tools chosen on the key.',
        },
        clients: {
            errorRevokedClient: 'This client has been revoked, so it has no secret to rotate.',
            paginationLabel: 'OAuth clients pages',
            intro: 'Clients that agent builders use with a client ID and secret. Clients that registered themselves are listed here too.',
            registerButton: 'Register client',
            empty: 'No OAuth clients yet.',
            error: 'The OAuth clients could not be read.',
            reload: 'Reload OAuth clients',
            colName: 'Name',
            colClientId: 'Client ID',
            colType: 'Type',
            colOrigin: 'Registered by',
            colRedirects: 'Redirect URIs',
            colScopes: 'Scopes',
            colTools: 'Tools',
            colLastUsed: 'Last used',
            colStatus: 'Status',
            colActions: 'Actions',
            typeConfidential: 'Confidential',
            typePublic: 'Public',
            originAdmin: 'An administrator',
            originDynamic: 'The client itself',
            statusActive: 'Active',
            statusRevoked: 'Revoked',
            rotateSecret: 'Rotate secret',
            revoke: 'Revoke',
            modalTitle: 'Register OAuth client',
            nameField: 'Name',
            nameHint: 'People see this name on the consent screen.',
            nameRequired: 'Enter a name.',
            typeField: 'Client type',
            typeConfidentialHint: 'Confidential — the client keeps a secret on a server. Use this for Slack and other agent builders.',
            typePublicHint: 'Public — the client cannot keep a secret (a desktop or browser app) and proves itself with PKCE instead.',
            redirectField: 'Redirect URIs',
            redirectHint: 'The exact addresses the client sends people back to. A loopback address such as localhost accepts any port.',
            redirectUriLabel: 'Redirect URI {n}',
            addRedirect: 'Add another redirect URI',
            removeRedirect: 'Remove redirect URI {n}',
            redirectInvalid: 'Enter a full address, for example https://example.com/callback.',
            redirectRequired: 'Add at least one redirect URI.',
            scopesField: 'Scopes',
            scopesRequired: 'Choose at least one scope.',
            toolsField: 'Limit to these tools (optional)',
            toolsHint: 'Leave every box clear to allow each tool the chosen scopes reach.',
            submit: 'Register client',
            saving: 'Registering…',
            errorCreate: 'Could not register the client.',
            createdTitle: 'Client registered',
            secretTitle: 'New client secret',
            secretOnce: 'Copy the client secret now. It is shown once and cannot be shown again; rotate the secret to get a new one.',
            publicNoSecret: 'This is a public client, so it has no secret. It signs in with PKCE.',
            clientIdLabel: 'Client ID',
            clientSecretLabel: 'Client secret',
            confirmRotateTitle: 'Rotate the client secret?',
            confirmRotateBody: 'The current secret stops working now. Put the new secret into the agent builder straight away.',
            errorRotate: 'Could not rotate the client secret.',
            confirmRevokeTitle: 'Revoke this OAuth client?',
            confirmRevokeBody: 'Every app connected through this client loses access now, and its connections are revoked. This cannot be undone.',
            confirmRevoke: 'Revoke client',
            errorRevoke: 'Could not revoke the client.',
        },
        grants: {
            errorNotFound: 'This connection no longer exists; it may already have been revoked.',
            paginationLabel: 'Connected apps pages',
            intro: 'Apps that people in this organisation approved on the consent screen. Revoking one stops its next call.',
            empty: 'No connected apps.',
            error: 'The connected apps could not be read.',
            reload: 'Reload connected apps',
            colApp: 'App',
            colUser: 'Approved by',
            colScopes: 'Scopes',
            colCreated: 'Connected',
            colLastUsed: 'Last used',
            colActions: 'Actions',
            revoke: 'Revoke',
            confirmRevokeTitle: 'Revoke this connection?',
            confirmRevokeBody: 'The app loses access now. The person can connect it again by approving it on the consent screen.',
            confirmRevoke: 'Revoke connection',
            errorRevoke: 'Could not revoke the connection.',
        },
        myApps: {
            errorNotFound: 'This app is no longer connected; it may already have been revoked.',
            title: 'Connected apps',
            intro: 'Apps you have allowed to use ComplianceOne on your behalf. Each acts as you, with no more access than your role gives you.',
            empty: 'You have not connected any apps.',
            error: 'Your connected apps could not be read.',
            reload: 'Reload connected apps',
            colApp: 'App',
            colScopes: 'Scopes',
            colCreated: 'Connected',
            colLastUsed: 'Last used',
            colActions: 'Actions',
            revoke: 'Revoke',
            confirmRevokeTitle: 'Revoke this app?',
            confirmRevokeBody: 'The app loses access now. You can connect it again by approving it on the consent screen.',
            confirmRevoke: 'Revoke app',
            errorRevoke: 'Could not revoke the app.',
        },
    },
    memory: {
        pageTitle: 'Memòria Forseti',
        pageSubtitle: "Exploreu i gestioneu el context específic de l'organització que Forseti ha acumulat a través de converses i decisions. Les entrades seleccionades es bloquegen contra la retenció nocturna i es mantenen disponibles per a totes les persones.",
        filterCategory: 'Categoria',
        filterAllCategories: 'Totes les categories',
        totalCount: '{count} entrades',
        colAnchor: 'Àncora',
        colCategory: 'Categoria',
        colSource: 'Font',
        colContent: 'Contingut',
        colCreatedAt: 'Creat',
        colActions: 'Accions',
        editButton: 'Edita',
        deleteButton: 'Suprimeix',
        promoteButton: 'Promocionar a comissariat',
        emptyState: 'Encara no hi ha records: Forseti acumularà context mentre converses.',
        categories: {
            framework_interpretation: 'Interpretació del marc',
            process_preference: 'Preferència del procés',
            escalation_threshold: "Llindar d'escalada",
            decision_context: 'Context de decisió',
            glossary_term: 'Terme del glossari',
            auto_inferred: 'Autoinferit',
        },
        sources: {
            admin_curated: 'Comissariat',
            user_explicit: 'Explícit',
            auto: 'Inferit',
        },
        deleteConfirmTitle: 'Vols suprimir aquesta memòria?',
        deleteConfirmBody: 'La supressió eliminarà aquesta àncora de cada arrencada de xat de Forseti futura. Àncora: {anchor}',
        deleteConfirmLabel: 'Suprimeix',
        deleteCancelLabel: 'Cancel·la',
        editModalTitle: 'Edita la memòria',
        editAnchorLabel: 'Àncora',
        editCategoryLabel: 'Categoria',
        editContentLabel: 'Contingut',
        editContentCount: '{n}/{max} caràcters',
        editEmptyError: 'El contingut no pot estar buit.',
        editTooLongError: 'El contingut ha de tenir ≤1000 caràcters.',
        editAutoPromoteHint: "Si deseu aquesta memòria autoinferida, la marcarà com a confirmada per l'usuari i l'eliminarà de l'escombrat de retenció.",
        editCancelButton: 'Cancel·la',
        editSaveButton: 'Desa',
        editSaving: "S'està desant…",
        loadFailed: 'The memories could not be loaded.',
        deleteFailed: 'The memory could not be deleted.',
        promoteFailed: 'The memory could not be promoted to curated.',
        saveFailed: 'The memory could not be saved.',
    },
    auditLineage: {
        title: "Llinatge d'auditoria",
        subtitle: "Traça cada artefacte generat per AI adjunt a un registre. Xats, trucades d'eines, tasques, esborranys d'evidències i versions de documents.",
        filterForm: 'Filtres',
        recordType: 'Tipus de registre',
        recordId: 'Identificació de registre',
        dateStart: 'Des de',
        dateEnd: 'A',
        search: 'Cerca',
        loading: "S'està carregant…",
        exportPdf: 'Exporta PDF',
        exportCsv: 'Exporta CSV',
        nodesHeading: 'Nodes de llinatge',
        colType: 'Tipus',
        colLabel: 'Etiqueta',
        colOccurredAt: 'Va passar a',
        colActor: 'Actor',
        colId: 'ID',
        noResults: "No hi ha activitat d'assessor per a aquest registre.",
        draftBadge: 'AI-esborrany generat',
        prev: 'Anterior',
        next: 'A continuació',
        viewToggleTable: 'Veure com a taula',
        viewToggleGraph: 'Veure com a gràfic',
        graphAriaLabel: "Gràfic de llinatge (visual). Utilitzeu la vista de taula per a la tecnologia d'assistència.",
        graphLegendDraft: 'Esborrany de AI prova',
        graphEmpty: 'No hi ha nodes per representar gràfics.',
        paginationAriaLabel: 'Paginació',
        exportSuccessTemplate: '{format}: {filename}',
        exportErrorTemplate: "Ha fallat l'exportació: {message}",
        truncatedNotice: "Aquest llinatge no és complet. La plataforma llegeix com a màxim un nombre fix de files de cada font i s'ha assolit el límit per a: {sources}. Les files més enllà d'un límit, si n'hi ha, no es mostren. Redueix l'interval de dates per incloure-les.",
        truncatedChatLinksNotice: 'This lineage is not complete: only the {limit} newest chats of this record are used to find the tool calls, workflow runs, tasks, evidence and document versions that were started from a chat. Anything reached only through an older chat is not shown, and narrowing the date range does not bring it in.',
        recordTypes: {
            project: 'Projecte',
            dpia: 'DPIA',
            transfer_assessment: 'Cross-border transfer assessment',
            dossier_filing: 'Dossier filing',
            cross_border_filing: 'Cross-border filing',
            vendor: 'Venedor',
            incident: 'Incident',
            incident_op: "Operació d'incidència",
            rights_request: 'Sol·licitud de drets',
            contract: 'Contracte',
            task: 'Tasca',
            data_mapping_activity: 'Activitat de mapeig de dades',
            compliance_rule: 'Norma de compliment',
            program: 'Programa',
        },
        nodeTypes: {
            chat: 'Xatejar',
            tool_call: "Crida d'eina",
            workflow_run: 'Execució del flux de treball',
            task: 'Tasca',
            evidence: 'Evidència',
            document_version: 'Versió del document',
        },
        recordIdManualHint: "This record type has no list here. Enter the record's own id, as it appears in the address of its page.",
        recordIdManualLabel: 'Record ID',
        colDetails: 'Details',
    },
    integrityCenter: {
        verdicts: {
            ok: "D'acord",
            drifted: 'A la deriva',
            hash_mismatch: 'Desconcordança de hash',
            merkle_mismatch: 'Desajust de Merkle',
            source_missing: 'Falta la font',
            not_found: "No s'ha trobat",
            chain_unreachable: 'Cadena inabastable',
            service_unreachable: 'Servei inaccessible',
            pending: 'Ancoratge pendent',
        },
    },
    evidenceDraft: {
        draftBadge: 'AI-esborrany generat',
        pendingReviewBadge: 'Pendent de revisió',
        approvedBadge: 'Aprovat',
        rejectedBadge: 'Rebutjat',
        moveToReviewButton: 'Marcar a punt per a la revisió',
        approveButton: 'Aprovar',
        rejectButton: 'Rebutja',
        rejectReasonLabel: 'Motiu de rebuig',
        humanSignoffBanner: "Forseti dóna suport al vostre judici; no substitueix l'advocat amb llicència. L'evidència generada per AI requereix l'aprovació humana abans de comptar com a prova formal.",
        pageTitle: 'AI esborranys de proves',
        pageSubtitle: 'Reviseu, aproveu o rebutgeu les proves generades per AI. Els esborranys han de ser aprovats per una persona abans de comptar com a prova formal.',
        filterAll: 'Tot accionable',
        filterDrafts: 'Només esborranys',
        filterPending: 'Pendent de revisió',
        filterApproved: 'Aprovat recentment',
        filterRejected: 'Rebutjat recentment',
        colId: 'Identificació de la prova',
        colStatus: 'Estat',
        colSource: 'Font',
        colCreatedAt: 'Creat',
        colActions: 'Accions',
        empty: "No hi ha AI esborranys d'evidència en aquest estat.",
        confirmApprove: 'Voleu aprovar aquesta prova generada per AI com a formal?',
        confirmReject: 'Rebutja aquest esborrany de proves. Això no es pot desfer.',
        reasonRequired: 'Cal un motiu de rebuig.',
        rejectModalTitle: "Rebutja l'esborrany de proves",
        approveModalTitle: "Aprovar l'esborrany de proves",
        operationFailed: "L'operació ha fallat. Si us plau, torna-ho a provar.",
        moveToReviewSuccess: "S'ha marcat com a preparat per a la revisió.",
        approveSuccess: 'Aprovat.',
        rejectSuccess: 'Rebutjat.',
        sourceLabelWorkflowRunTitle: 'Flux de treball: {title}',
        sourceLabelWorkflowRunId: 'Execució del flux de treball {id}',
        sourceLabelChatTitle: 'Xat: {title}',
        sourceLabelChatId: 'Forseti xat {id}',
        sourceLabelEmpty: '—',
        filtersAriaLabel: 'Estat del filtre',
    },
    workflows: {
        pageTitle: 'Fluxos de treball IA',
        pageSubtitle: 'Plantilles desades de prompts IA que generen tasques i esborranys de proves.',
        newWorkflow: 'Nou flux de treball',
        newWorkflowHeading: 'Nou flux de treball IA',
        tabAll: 'Tots',
        tabBuiltin: 'Paquet integrat',
        tabMine: 'Els meus fluxos',
        tabDetail: 'Detalls',
        tabLinkedTasks: 'Tasques enllaçades',
        builtinBadge: 'Integrat',
        builtinSubtitle: 'Flux de treball integrat.',
        userSubtitle: 'Flux de treball personalitzat.',
        emptyHint: 'Encara no hi ha fluxos de treball.',
        loadTimeoutError: "No s'han pogut carregar els fluxos de treball després de 10 segons. Reintenteu, o reviseu la pestanya Xarxa del navegador per veure si hi ha una sol·licitud penjada.",
        loadError: "No s'han pogut carregar els fluxos de treball.",
        hideError: 'Ha fallat amagar.',
        unhideError: 'Ha fallat mostrar.',
        retry: 'Reintentar',
        producesTasks: 'Genera tasques',
        producesEvidence: 'Genera esborranys de proves',
        hideButton: 'Amagar de la meva llista',
        unhideButton: 'Mostrar',
        runButton: 'Executar',
        editButton: 'Editar',
        shareButton: 'Compartir',
        backToList: 'Tornar a la llista',
        requireTitleAndPrompt: 'Cal el títol i el prompt.',
        fieldTitle: 'Títol',
        fieldDescription: 'Descripció',
        fieldType: 'Tipus',
        fieldPersona: 'Afinitat de persona',
        fieldPractice: 'Pràctica',
        fieldPrompt: 'Sol·licitud (reducció)',
        fieldProducesTasks: 'Genera tasques',
        fieldProducesEvidence: 'Genera esborranys de proves',
        fieldProjectId: 'Projecte (opcional)',
        fieldAttachmentIds: 'Adjunts',
        fieldParentRecord: 'Registre pare (opcional)',
        fieldPersonaOverride: 'Substituir persona (opcional)',
        typeAssistant: 'Assistent',
        typeTabular: 'Tabular',
        personaNone: '— cap —',
        parentNone: '— cap —',
        parentIdPlaceholder: 'ID del registre pare',
        selectProjectPlaceholder: 'Seleccioneu un projecte…',
        selectProjectFirst: 'Seleccioneu un projecte per triar adjunts.',
        selectAttachmentsPlaceholder: 'Seleccioneu documents…',
        noAttachmentsInProject: 'Aquest projecte no té documents adjunts.',
        selectParentRecordPlaceholder: 'Seleccioneu un registre…',
        selectParentRecordFirst: 'Seleccioneu primer un tipus de registre.',
        noRecordsForType: "No hi ha registres disponibles d'aquest tipus.",
        shareUserSelectorLabel: 'Destinataris (usuaris)',
        shareGroupSelectorLabel: "Destinataris (grups d'organització)",
        selectUsersPlaceholder: 'Seleccioneu usuaris…',
        selectOrgGroupsPlaceholder: "Seleccioneu grups d'organització…",
        loadingOptions: 'Carregant…',
        loadFailed: "No s'han pogut carregar les opcions.",
        parentRecordTypes: {
            dpia: 'DPIA',
            vendor: 'Proveïdor',
            incident: 'Incident',
            rights_request: 'Sol·licitud de drets',
            contract: 'Contracte',
            data_mapping_activity: 'Activitat RoPA',
            compliance_rule: 'Regla de compliment',
            program: 'Programa',
        },
        cancelButton: 'Cancel·lar',
        closeButton: 'Tancar',
        createButton: 'Crear',
        creating: 'Creant…',
        saveButton: 'Desar',
        saving: 'Desant…',
        shareWorkflowHeading: 'Compartir flux de treball',
        shareIntro: 'Compartint: {title}',
        shareUserIds: "IDs d'usuari (separats per espai o coma)",
        shareGroupIds: "IDs de grup d'organització (separats per espai o coma)",
        shareAllowEdit: 'Permetre editar als destinataris',
        shareRequireRecipient: "Indiqueu almenys un id d'usuari o de grup.",
        shareSuccess: 'Compartit.',
        sharing: 'Compartint…',
        runWorkflowHeading: 'Executar: {title}',
        runStarting: 'Iniciant…',
        runStatusLabel: 'Estat: {status}',
        runProducedCounts: 'Tasques: {tasks} · Esborranys de proves: {evidence} · Fitxers adjunts: {attachments}',
        runPanelHeading: 'Execució del flux de treball',
        runPanelHeadingWithTitle: 'Execució del flux de treball: {title}',
        runViewTasks: 'Mostra les tasques generades',
        runViewEvidence: 'Mostra evidències esborrany',
        runResultHeading: "Resultat de l'assessor",
        runNoResult: "L'execució ha acabat però no ha retornat un resultat que es pugui revisar. No s'han creat tasques, evidències ni fitxers adjunts. Torna-ho a provar amb el registre o els documents necessaris seleccionats.",
        runCitationWarning: "Algunes citacions no s'han pogut verificar automàticament. Revisa-les abans de basar-te en aquest resultat.",
        runToolCallWarning: 'Forseti attempted a tool this workflow could not run, and returned the attempt as text. Nothing was produced from it.',
        runNoEnvelopeWarning: 'Forseti returned a result this workflow could not read, so no tasks or evidence were created from it.',
        runNoArtefactsWarning: 'This run completed without creating any tasks or draft evidence. Review the result before treating the work as done.',
        runLoadFailed: 'No s’ha pogut carregar l’execució del flux de treball.',
        runStreamFailed: 'Ha fallat la connexió amb el progrés del flux de treball.',
        runStatusValues: {
            pending: 'Pendent',
            running: 'En execució',
            completed: 'Completat',
            succeeded: 'Correcte',
            failed: 'Fallit',
            cancelled: 'Cancel·lat',
        },
        runProgressStatus: 'Estat: {status}',
        runProgressTaskCreated: 'Tasca creada.',
        runProgressEvidenceDrafted: 'Esborrany de prova creat.',
        runProgressAttachmentGenerated: 'Fitxer adjunt generat.',
        guidedWorkflowTitle: 'Flux de treball guiat de {recordType}',
        guidedWorkflowDescription: 'Creat per a registres de tipus {recordType}. Reviseu i personalitzeu aquest flux de treball abans de desar-lo.',
        guidedWorkflowPrompt: 'Reviseu el registre de tipus {recordType} proporcionat, identifiqueu els fets que falten i proposeu els passos següents fonamentats per a revisió humana.',
        promptHeading: 'Avís',
        howItWorksHeading: 'Què passa quan executes aquest flux de treball',
        builtinGuidance: "Forseti revisa els registres i documents que seleccioneu, retorna un resultat revisable per l'operador i crea tasques o evidències en esborrany només quan el resultat ho justifica. Res no s'aprova ni s'envia automàticament.",
        editWorkflowHeading: 'Editar flux de treball',
        linkedTasksHint: 'Tasks created by this workflow show up in the Tasks list, filtered by this workflow’s ID.',
        notFound: 'Flux de treball no trobat.',
        schedules: {
            tabTitle: 'Programacions',
            sectionHeading: 'Execucions programades',
            empty: 'Encara no hi ha programacions. Creeu-ne una per executar aquest flux de treball automàticament.',
            addButton: 'Afegir programació',
            addHeading: 'Programar flux de treball',
            editHeading: 'Editar programació',
            fieldFrequency: 'Freqüència',
            fieldDayOfWeek: 'Dia de la setmana',
            fieldDayOfMonth: 'Dia del mes',
            fieldTime: 'Hora (UTC)',
            fieldTimezone: 'Zona horària',
            fieldProject: 'Projecte (opcional)',
            fieldAttachments: 'Adjunts per defecte',
            fieldPersonaOverride: 'Substituir persona (opcional)',
            frequencyDaily: 'Diària',
            frequencyWeekly: 'Setmanal',
            frequencyMonthly: 'Mensual',
            weekdaySun: 'Diumenge',
            weekdayMon: 'Dilluns',
            weekdayTue: 'Dimarts',
            weekdayWed: 'Dimecres',
            weekdayThu: 'Dijous',
            weekdayFri: 'Divendres',
            weekdaySat: 'Dissabte',
            statusActive: 'Actiu',
            statusPaused: 'En pausa',
            nextRunLabel: 'Següent execució',
            lastRunLabel: 'Última execució',
            pauseButton: 'Pausar',
            resumeButton: 'Reprendre',
            deleteButton: 'Eliminar',
            triggerButton: 'Executar ara',
            savingButton: 'Desant…',
            saveButton: 'Desar',
            triggered: "Execució iniciada — reviseu l'historial d'execucions.",
        },
        branching: {
            helpHeading: 'Sintaxi de prompt condicional',
            helpBody: 'Use {% if persona.slug == "forseti-legal" %}…{% endif %} to vary the prompt by context. Variables with a value: persona.slug (the persona chosen when the run starts, otherwise the workflow’s persona), org.country and org.locale (your organisation’s country and default language), and project.name (the project the run belongs to). attachment.framework_code, attachment.locale and project.tier are accepted but currently have no source, so {{ }} on them renders empty and a condition on them is always false. Nested {% if %} blocks are not supported.',
        },
        runCancelButton: 'Cancel run',
        runCancelling: 'Cancelling…',
        runCancelRequested: 'Cancellation requested. The model request already under way cannot be recalled, but when it returns its answer is discarded and no tasks, draft evidence or files are created.',
        runCancelledNote: 'This run was cancelled. No tasks, draft evidence or files were created from it.',
        runCancelFailed: 'Could not cancel the run.',
    },
    crossFrameworkConflicts: {
        pageTitle: 'Conflictes entre marcs',
        pageSubtitle: "Catàleg seleccionat d'on interactuen els vostres paquets reguladors instal·lats de maneres contradictòries. superfícies Forseti; els humans decideixen.",
        noInstalledPacks: 'No hi ha paquets normatius instal·lats per a aquesta organització: instal·leu almenys dos paquets per aclarir conflictes entre marcs.',
        noConflicts: 'No hi ha cap conflicte que coincideixi amb els filtres actuals.',
        allAcknowledged: 'Tots els conflictes visibles han estat reconeguts. Bona feina.',
        columnSeverity: 'Severitat',
        columnTitle: 'Títol',
        columnFrameworks: 'Marcs',
        columnTopic: 'Tema',
        columnStatus: 'Estat',
        filterFrameworkPlaceholder: 'Tots els marcs',
        filterTopicPlaceholder: 'Tots els temes',
        filterSeverityPlaceholder: 'Totes les gravetats',
        filterStatusPlaceholder: 'Tots els estats',
        filterStatusAcknowledged: 'Reconegut',
        filterStatusUnacknowledged: 'No reconegut',
        severityCritical: 'Crític',
        severityHigh: 'Alt',
        severityMedium: 'Mitjana',
        severityLow: 'Baixa',
        statusAcknowledged: 'Reconegut',
        statusInReview: 'En revisió',
        statusResolved: 'Solucionat',
        statusWontFix: 'No arreglarà',
        statusUnacknowledged: 'No reconegut',
        drawerSummaryHeading: 'Resum',
        drawerSideAHeading: 'Cara A',
        drawerSideBHeading: 'Cara B',
        drawerRequirementsLabel: 'Requisits citats',
        drawerProvisionsLabel: 'Disposicions citades',
        drawerSuggestedResolutionHeading: 'Resolució suggerida',
        drawerLegalCounselBadge: "Cal revisió d'un assessor legal",
        drawerAckHeading: 'Reconeixement',
        drawerAckStatusLabel: 'Estat',
        drawerAckAssigneeLabel: 'Assignat a',
        drawerAckDueDateLabel: 'Data de venciment',
        drawerAckNotesLabel: 'Notes',
        drawerAckButtonAcknowledge: 'Reconèixer',
        drawerAckButtonUpdate: 'Actualització',
        drawerAckButtonUnacknowledge: 'Des-reconèixer',
        // fix-sprint-20260912-2123 F23 — R-57: structural parity, EN value carried.
        drawerCloseLabel: 'Close',
        drawerAckAssigneePlaceholder: 'User ID',
        drawerAckSaveFailed: 'Could not save the acknowledgement.',
        drawerAckUnacknowledgeFailed: 'Could not remove the acknowledgement.',
        loadFailed: 'Could not load conflicts.',
        searchPlaceholder: 'Cerca títol o resum...',
        searchButton: 'Cerca',
        searchButtonAriaLabel: 'Executeu la cerca de conflictes',
        exportSuccessTemplate: 'CSV: {filename}',
        exportSuccessTemplateXlsx: 'XLSX: {filename}',
        exportErrorTemplate: "Ha fallat l'exportació: {message}",
        exportAriaLabel: "Conflictes d'exportació",
        // fix-sprint D1 F23 — the page-level load failure now renders through
        // `withRetry`, which needs the control's label, its busy label and the
        // subject a screen reader hears after it.
        reload: 'Reload',
        reloading: 'Reloading…',
        retrySubject: 'the conflict list',
    },
    tabularReviews: {
        pageTitle: 'Revisions tabulars',
        pageSubtitle: 'Compareu N documents en M atributs amb cites fonamentades.',
        newReview: 'Nova revisió',
        newReviewHeading: 'Nova revisió tabular',
        emptyHint: 'Encara no hi ha revisions tabulars.',
        docsLabel: '{n} documents',
        colsLabel: '{n} columnes',
        detailSubtitle: '{docs} documents · {cols} columnes',
        addColumn: 'Afegir columna',
        addColumnHeading: 'Afegir columna',
        columnInfo: 'Mostra la indicació i el format',
        columnInfoAria: 'Mostra la indicació i el format de la columna {name}',
        columnInfoPrompt: 'Indicació',
        columnInfoFormat: 'Format de retorn',
        columnInfoPresets: 'Valors permesos',
        columnInfoCitations: 'Cites',
        columnInfoCitationsRequired: 'Obligatori',
        removeColumn: 'Elimina la columna',
        removeColumnAria: 'Elimina la columna {name}',
        removeColumnConfirm: 'Voleu eliminar la columna "{name}"? Se n\'eliminaran les cel·les extretes.',
        deleteReview: 'Elimina',
        deleteReviewAria: 'Elimina la revisió {title}',
        deleteReviewConfirm: 'Voleu eliminar la revisió "{title}"? Això n\'elimina permanentment les columnes, cel·les i debats.',
        runAll: 'Executar tot',
        running: 'Executant…',
        cancel: 'Cancel·lar',
        exportXlsx: 'Exportar Excel',
        exportCsv: 'Exportar CSV',
        exporting: 'Exportant…',
        backToList: 'Tornar a la llista',
        notFound: 'Revisió tabular no trobada.',
        loadFailed: 'The tabular review could not be read. Reload to try again.',
        emptyPayload: 'The server answered without the tabular review. Reload to try again.',
        reload: 'Reload',
        reloading: 'Reloading…',
        retrySubject: 'this tabular review',
        cancelFailed: 'The run could not be cancelled.',
        removeColumnFailed: 'The column could not be removed.',
        exportFailed: 'The export could not be produced.',
        noDocuments: 'Adjunteu documents per iniciar la revisió.',
        noColumns: 'Afegiu columnes per definir què extraure.',
        tableAriaLabel: "Graella d'extracció",
        threadsCountAria: '{n} publicació(ns) de discussió',
        startDiscussionAria: 'Iniciar discussió',
        docColumn: 'Document',
        statusPending: 'Pendent',
        statusRunning: 'Executant…',
        statusFailed: 'Fallit: {msg}',
        statusCancelled: 'Cancel·lat',
        citationsCount: '{n} cita(es)',
        citationsView: 'Mostra els passatges d’origen',
        citationPage: 'Pàgina {n}',
        titleRequired: 'Cal un títol.',
        fieldTitle: 'Títol',
        fieldProjectId: 'Projecte (opcional)',
        fieldAttachmentIds: 'Adjunts',
        fieldColumnName: 'Nom de la columna',
        fieldColumnNameHelp: "Una etiqueta curta i descriptiva per a aquesta columna a la graella d'extracció.",
        columnNamePlaceholder: "p. ex. Data d'inici del contracte",
        fieldExtractionPrompt: "Prompt d'extracció",
        fieldExtractionPromptHelp: 'Descriviu la informació que voleu extreure. Sigueu específics per obtenir millors resultats.',
        columnPromptPlaceholder: 'Què ha de buscar Forseti als documents?',
        fieldReturnFormat: 'Format de retorn',
        fieldReturnFormatHelp: 'Controla com la IA formata la seva resposta (per exemple, com a data o número).',
        fieldPresets: 'Valors permesos (un per línia)',
        fieldPresetsPlaceholder: 'sí\nno\nparcial',
        fieldCitationsRequired: 'Cita obligatòria',
        formatShortText: 'Text curt',
        formatLongText: 'Text llarg',
        formatEnum: 'Enum',
        formatNumber: 'Número',
        formatDate: 'Data',
        formatList: 'Llista',
        columnRequireFields: 'Cal el nom i el prompt.',
        addColumnError: 'No s ha pogut afegir la columna.',
        cancelButton: 'Cancel·lar',
        createButton: 'Crear',
        creating: 'Creant…',
        addButton: 'Afegir',
        adding: 'Afegint…',
        runConfirmHeading: 'Executar extracció',
        estimateBody: 'Estimació de ~{units} unitats facturables (confiança {confidence}).',
        starting: 'Iniciant…',
        confirmRun: 'Confirmar execució',
        charts: {
            title: 'Gràfics de columnes',
            tabsAria: 'Columnes de gràfics',
            enumAria: 'Distribució de valors enum',
            numberAria: 'Histograma de distribució numèrica',
            dateAria: 'Línia de temps de dates',
            enumEmpty: 'No hi ha cel·les completades.',
            numberEmpty: 'No hi ha valors numèrics.',
            numberExcluded: '{n} cel·la(es) excloses (buides / no numèriques / no completades).',
            dateEmpty: 'No hi ha valors de data.',
            dateExcluded: '{n} cel·la(es) excloses.',
            unsupportedFormat: 'Format de columna no suportat.',
        },
        threads: {
            drawerTitle: 'Discussió',
            loading: 'Carregant…',
            empty: 'Encara no hi ha publicacions. Inicieu la conversa.',
            composerLabel: 'Nou comentari',
            composerPlaceholder: 'Afegir un comentari…',
            post: 'Publicar',
            posting: 'Publicant…',
            edit: 'Editar',
            editLabel: 'Editar publicació',
            delete: 'Eliminar',
            save: 'Desar',
            cancel: 'Cancel·lar',
            close: 'Tancar',
            editedBadge: 'editat',
            loadError: "No s'ha pogut carregar el fil",
            postError: "No s'ha pogut publicar",
            editError: "No s'ha pogut editar",
            deleteError: "No s'ha pogut eliminar",
        },
        compare: {
            pageTitle: 'Comparar revisions',
            leftReviewLabel: 'Revisió esquerra',
            rightReviewLabel: 'Revisió dreta',
            pickReview: 'Trieu una revisió per comparar',
            noSharedDocuments: 'Aquestes revisions no comparteixen documents — la comparació requereix almenys un adjunt comú.',
            sharedDocumentsHeading: 'Documents compartits',
            leftOnlyHeading: 'Columnes només a la revisió esquerra',
            rightOnlyHeading: 'Columnes només a la revisió dreta',
            differs: 'Difereix',
            identical: 'Idèntic',
            emptyValue: '—',
            compareButton: 'Comparar amb…',
            documentHeading: 'Document',
            errorMissingIds: 'Calen els ids de la revisió esquerra i dreta.',
            errorComparisonFailed: 'La comparació ha fallat.',
            errorLoadFailed: "No s'han pogut carregar les revisions.",
            pickerLoading: 'Carregant…',
            pickerNoOtherReviews: 'No hi ha altres revisions disponibles per comparar.',
            pickerCancel: 'Cancel·lar',
        },
    },
    documentReview: {
        pageTitle: 'Revisió de documents',
        pageSubtitle: 'Accepteu o rebutgeu les modificacions suggerides per AI en aquest document.',
        sidePanelLabel: 'AI línies vermelles',
        sidePanelHeading: 'AI línies vermelles',
        noPendingEdits: 'No hi ha modificacions pendents.',
        pendingCount: '{count} pendent',
        acceptAllButton: 'Acceptar-ho tot',
        rejectAllButton: 'Rebutja-ho tot',
        acceptAllTitle: 'Accepteu totes les edicions pendents?',
        acceptAllConfirm: 'Això acceptarà {count} edicions pendents i crearà una o més versions noves. Continuar?',
        editsHeading: 'Edicions',
        editsEmpty: 'No hi ha modificacions per revisar.',
        versionsHeading: 'Historial de versions',
        versionsEmpty: 'Encara no hi ha cap versió.',
        editLabel: 'Edita',
        editLabelWithId: 'Edita #{id}',
        acceptButton: 'Acceptar',
        rejectButton: 'Rebutja',
        accepting: "S'està acceptant…",
        rejecting: "S'està rebutjant...",
        diffDeletedAria: "S'ha suprimit",
        diffInsertedAria: "S'ha inserit",
        statusPending: 'Pendent',
        statusAccepted: 'Acceptat',
        statusRejected: 'Rebutjat',
        versionLabel: 'Versió',
        versionAriaLabel: 'Versió {n}',
        versionAriaLabelCurrent: 'Versió {n} ({current})',
        versionCurrentTag: 'actual',
        versionSourceLabel: 'Font',
        versionCreatedLabel: 'Creat',
        versionModelLabel: 'Model',
        sourceUpload: 'Carrega',
        sourceUserUpload: "Càrrega d'usuari",
        sourceAssistantEdit: "Assistent d'edició",
        sourceUserAccept: "L'usuari ha acceptat l'edició",
        sourceUserReject: "L'usuari ha rebutjat l'edició",
        sourceGenerated: 'Generat',
        extractionExtracted: 'Text extret',
        extractionFailed: 'L’extracció de text ha fallat',
        extractionUnsupported: 'No s’ha pogut extreure el text',
        extractionPages: '{n} pàgines',
        extractionWords: '{n} paraules',
        extractionReasonScanned: 'Això sembla un document escanejat o només d’imatges. Forseti encara no el pot llegir: pugeu un fitxer de text o enganxeu-ne el contingut directament.',
        extractionReasonEncrypted: 'El fitxer està protegit amb contrasenya. Traieu-ne la protecció i torneu-lo a pujar.',
        extractionReasonMalformed: 'No s’ha pogut analitzar el fitxer i pot estar malmès.',
        extractionReasonParserUnavailable: 'The server’s PDF reader is not installed correctly, so the text could not be read. This says nothing about your file. Ask an administrator to check the installation.',
        extractionReasonTooLarge: 'El fitxer és massa gran per processar-lo.',
        extractionReasonTimeout: 'El processament ha trigat massa. Proveu amb un fitxer més petit o senzill.',
        extractionReasonUnknown: 'No hi ha més detalls disponibles.',
        // Sprint B - Forseti actions on the document review detail page.
        // EN values pending the next 56.x locale fan-out sprint.
        askForsetiButton: 'Ask Forseti',
        runRedlineButton: 'Run redline',
        forsetiModalTitleAsk: 'Ask Forseti — {name}',
        forsetiModalTitleRedline: 'Run redline — {name}',
        forsetiGuidanceAsk: 'Ask Forseti about this document. Pick a starter below or type your own question.',
        forsetiGuidanceRedline: 'Forseti will read this document and propose redline edits. Pick the redline starter below to begin — edits appear in the panel for you to accept or reject.',
        forsetiStarterRedline: 'Read attachment {id} and propose redline edits for legal and compliance issues',
        forsetiStarterSummarise: 'Summarise the key obligations in attachment {id}',
        forsetiStarterRisks: 'Review attachment {id} for legal risks and missing clauses',
        forsetiStarterFrameworks: 'Which compliance frameworks apply to attachment {id}?',
        textPaneLabel: 'Text del document',
        textPaneTitle: 'Text del document',
        textPaneVersion: 'Versió {n}',
        textPaneEmpty: 'No hi ha text disponible per a aquesta versió. Els PDF escanejats i alguns tipus de document no tenen text extraïble.',
        downloadVersionAria: 'Download version {n}',
        downloadVersionButton: 'Download',
        rejectAllConfirm: 'This rejects {count} pending edits. The reason you give is recorded on each one.',
        rejectAllTitle: 'Reject all pending edits?',
        rejectReasonShown: 'Reason',
        rejectConfirmButton: 'Confirm rejection',
        rejectReasonLabel: 'Reason for rejecting (optional)',
        loadRedlinesFailed: 'Failed to load redlines',
        acceptEditsFailed: 'Failed to accept edits',
        rejectEditsFailed: 'Failed to reject edits',
        batchPartialFailure: '{failed} of {total} failed: {reason}',
        actionFailed: 'Action failed',
    },
    documentReviewIndex: {
        sidebarLabel: 'Revisió de documents',
        pageTitle: 'Revisió de documents',
        pageSubtitle: 'Documents de la vostra organització amb edicions suggerides per IA pendents de revisió o versions originades per Forseti.',
        colDocument: 'Document',
        colLinkedRecord: 'Registre enllaçat',
        colPendingEdits: 'Edicions pendents',
        colLastActivity: 'Darrera activitat',
        colOpen: 'Obrir',
        open: 'Obrir',
        empty: 'Encara no hi ha cap document en revisió per Forseti. Els documents entren en aquesta cua quan Forseti suggereix una edició durant un xat, quan un flux IA produeix una marca de revisió, o quan envieu un document per a revisió usant el botó superior.',
        loading: 'Carregant…',
        loadError: "No s'han pogut carregar els documents en revisió.",
        retryButton: 'Reintentar',
        noLinkedRecord: '—',
        pendingZero: 'Cap',
        sendForReviewButton: 'Enviar un document per a revisió',
        sendForReviewTitle: 'Enviar un document per a revisió',
        sendForReviewSubtitle: 'Pugeu un document .txt, .md, .pdf o .docx (fins a 50 MB). S’afegirà a la cua de revisió i Forseti hi farà una passada de revisió.',
        sendForReviewTabUpload: 'Pujar nou',
        sendForReviewPickerLabel: 'Cercar adjunts',
        sendForReviewPickerPlaceholder: 'Escriviu per cercar…',
        sendForReviewPickerEmpty: 'No hi ha adjunts coincidents. Proveu una altra cerca.',
        sendForReviewSubmit: 'Enviar per a revisió',
        sendForReviewCancel: 'Cancel·lar',
        sendForReviewSubmitting: 'Enviant…',
        sendForReviewError: "No s'ha pogut enviar el document per a revisió. Torneu-ho a provar.",
        sendForReviewSuccess: 'Document enviat per a revisió.',
        sendForReviewAcceptedExt: 'Acceptats: {ext}.',
        sendForReviewMaxSize: 'Mida màxima {mb} MB.',
    },
    chats: {
        exportError: "L'exportació ha fallat.",
    },
};
//# sourceMappingURL=ca-extras.js.map